{
  "version": 1,
  "note": "Written by `pnpm worlds:import` (scripts/worlds). Do not edit by hand. ADR-032.",
  "files": [
    {
      "id": "259740_99-hq.ogg",
      "provider": "freesound",
      "asset": "amsterdam-street",
      "kind": "audio",
      "sound": "Amsterdam city centre 3 amb, trams traffic people, Spui",
      "user": "eruk",
      "page": "https://freesound.org/people/eruk/sounds/259740/",
      "licence": "CC0-1.0",
      "worlds": [
        "modern-street"
      ],
      "sourceUrl": "https://cdn.freesound.org/previews/259/259740_99-hq.ogg",
      "etag": "\"54a2c3db-459a29\"",
      "md5": "4f2d4b1f2d1a8d405c230fa6eacc4954",
      "sourceSha256": "7939f1f7b4fe854f4b9893e702d4dcf45e3c8ed29252969ef64ad84b86bf1d67",
      "stored": "7939f1f7b4fe854f4b9893e702d4dcf45e3c8ed29252969ef64ad84b86bf1d67.ogg",
      "bytes": 4561449,
      "served": false,
      "seconds": 203.09
    },
    {
      "id": "263573_4536481-hq.ogg",
      "provider": "freesound",
      "asset": "museum-hall",
      "kind": "audio",
      "sound": "London Museum Inside 1",
      "user": "Alcappuccino",
      "page": "https://freesound.org/people/Alcappuccino/sounds/263573/",
      "licence": "CC0-1.0",
      "worlds": [
        "museum-hall"
      ],
      "sourceUrl": "https://cdn.freesound.org/previews/263/263573_4536481-hq.ogg",
      "etag": "\"54d729d1-158b95\"",
      "md5": "68a785204d970afb3e91ca85e86d182d",
      "sourceSha256": "de10aab2765c1bdd8092f70a69ad68f8975ac5302ccab9e2a9ab04711c9a6bc6",
      "stored": "de10aab2765c1bdd8092f70a69ad68f8975ac5302ccab9e2a9ab04711c9a6bc6.ogg",
      "bytes": 1411989,
      "served": false,
      "seconds": 70.92
    },
    {
      "id": "345846_4622540-hq.ogg",
      "provider": "freesound",
      "asset": "windmill",
      "kind": "audio",
      "sound": "Inside a traditional Dutch windmill, 2",
      "user": "pcwvdmark",
      "page": "https://freesound.org/people/pcwvdmark/sounds/345846/",
      "licence": "CC0-1.0",
      "worlds": [
        "polder"
      ],
      "sourceUrl": "https://cdn.freesound.org/previews/345/345846_4622540-hq.ogg",
      "etag": "\"5737139c-d8d54\"",
      "md5": "85db3e8ffa228b9623d25e4fca49dd66",
      "sourceSha256": "b2a750f213ea0727911c6cf49936478b144f9c340505a347040bd055a4e0615f",
      "stored": "b2a750f213ea0727911c6cf49936478b144f9c340505a347040bd055a4e0615f.ogg",
      "bytes": 888148,
      "served": false,
      "seconds": 41.12
    },
    {
      "id": "363003_4000697-hq.ogg",
      "provider": "freesound",
      "asset": "market",
      "kind": "audio",
      "sound": "Wegetable market Poznan R.Jezycki",
      "user": "PITFACTORY",
      "page": "https://freesound.org/people/PITFACTORY/sounds/363003/",
      "licence": "CC0-1.0",
      "worlds": [
        "town-square"
      ],
      "sourceUrl": "https://cdn.freesound.org/previews/363/363003_4000697-hq.ogg",
      "etag": "\"5806586d-3549df\"",
      "md5": "267e898fe2c51c5eeab1a037ce0dfae6",
      "sourceSha256": "d25d0b90b7471511715252fd96a6e0c2272818bc0b4b2a728c33b8a636c1ba45",
      "stored": "d25d0b90b7471511715252fd96a6e0c2272818bc0b4b2a728c33b8a636c1ba45.ogg",
      "bytes": 3492319,
      "served": false,
      "seconds": 134.79
    },
    {
      "id": "385280_2341984-hq.ogg",
      "provider": "freesound",
      "asset": "forest-birds",
      "kind": "audio",
      "sound": "sfx_amb_forest_spring_afternoon-01",
      "user": "bajko",
      "page": "https://freesound.org/people/bajko/sounds/385280/",
      "licence": "CC0-1.0",
      "worlds": [
        "forest"
      ],
      "sourceUrl": "https://cdn.freesound.org/previews/385/385280_2341984-hq.ogg",
      "etag": "\"58d4dac4-2ce592\"",
      "md5": "43c65913a498feb6e10cc130c21cdf62",
      "sourceSha256": "d350a85d37cf1def87b6c89679ac0e4403375ee29e724697949114550c6248f2",
      "stored": "d350a85d37cf1def87b6c89679ac0e4403375ee29e724697949114550c6248f2.ogg",
      "bytes": 2942354,
      "served": false,
      "seconds": 137.17
    },
    {
      "id": "538016_11982267-hq.ogg",
      "provider": "freesound",
      "asset": "gulls",
      "kind": "audio",
      "sound": "Herring Gull 1",
      "user": "Canardo55",
      "page": "https://freesound.org/people/Canardo55/sounds/538016/",
      "licence": "CC0-1.0",
      "worlds": [
        "beach",
        "volcanic-island"
      ],
      "sourceUrl": "https://cdn.freesound.org/previews/538/538016_11982267-hq.ogg",
      "etag": "\"5f7b39fe-3945b\"",
      "md5": "8fa15d370ef3bf0e3098b3ef52efe5ce",
      "sourceSha256": "ed49177d4dbfd2f2bcf10b4617931a0d08b1b811ff1c39cfb63391b9b7c6807c",
      "stored": "ed49177d4dbfd2f2bcf10b4617931a0d08b1b811ff1c39cfb63391b9b7c6807c.ogg",
      "bytes": 234587,
      "served": false,
      "seconds": 33.33
    },
    {
      "id": "688868_6903350-hq.ogg",
      "provider": "freesound",
      "asset": "polder-larks",
      "kind": "audio",
      "sound": "Larks and wind",
      "user": "Elanor1995",
      "page": "https://freesound.org/people/Elanor1995/sounds/688868/",
      "licence": "CC0-1.0",
      "worlds": [
        "polder"
      ],
      "sourceUrl": "https://cdn.freesound.org/previews/688/688868_6903350-hq.ogg",
      "etag": "\"64739907-340877\"",
      "md5": "6c61661ab14f7e2ac1fd036ad4fc83af",
      "sourceSha256": "e6315c8ad0a79c1f0de48dacba07cea2c06cbeba4f65de5e9843d3711b83d380",
      "stored": "e6315c8ad0a79c1f0de48dacba07cea2c06cbeba4f65de5e9843d3711b83d380.ogg",
      "bytes": 3410039,
      "served": false,
      "seconds": 159.02
    },
    {
      "id": "701282_1629501-hq.ogg",
      "provider": "freesound",
      "asset": "pigeons",
      "kind": "audio",
      "sound": "pigeon walking and cooing.wav",
      "user": "5ro4",
      "page": "https://freesound.org/people/5ro4/sounds/701282/",
      "licence": "CC0-1.0",
      "worlds": [
        "town-square"
      ],
      "sourceUrl": "https://cdn.freesound.org/previews/701/701282_1629501-hq.ogg",
      "etag": "\"64f33f35-69f68\"",
      "md5": "4b17026637443730b9d024d307875df1",
      "sourceSha256": "4a924e4bd298f4596fb067d4e1f283b0a62e23a81f7997d737e15d1976e4e9bb",
      "stored": "4a924e4bd298f4596fb067d4e1f283b0a62e23a81f7997d737e15d1976e4e9bb.ogg",
      "bytes": 434024,
      "served": false,
      "seconds": 37.24
    },
    {
      "id": "815552_1481531-hq.ogg",
      "provider": "freesound",
      "asset": "summer-meadow",
      "kind": "audio",
      "sound": "Summer meadow - Houghton Lodge",
      "user": "richwise",
      "page": "https://freesound.org/people/richwise/sounds/815552/",
      "licence": "CC0-1.0",
      "worlds": [
        "meadow"
      ],
      "sourceUrl": "https://cdn.freesound.org/previews/815/815552_1481531-hq.ogg",
      "etag": "\"686e7ac8-2e4704\"",
      "md5": "a77a962c3fb8aa3d1806527d5a329de2",
      "sourceSha256": "3abf99c7bbc87c1122429bf50ed6047933bd7da7366586d65549f6e6bfdd8eb1",
      "stored": "3abf99c7bbc87c1122429bf50ed6047933bd7da7366586d65549f6e6bfdd8eb1.ogg",
      "bytes": 3032836,
      "served": false,
      "seconds": 113.82
    },
    {
      "id": "aerial_grass_rock_diff_1k.jpg",
      "provider": "polyhaven",
      "asset": "aerial_grass_rock",
      "kind": "texture",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Textures/jpg/1k/aerial_grass_rock/aerial_grass_rock_diff_1k.jpg",
      "md5": "e920ce36afd0abff000b8366d3d768d3",
      "sourceSha256": "57b8041bfe0d0f01430e4dbaad45e7ddddf0a9fc97317f90dbc51f7b0d9e1b5d",
      "stored": "57b8041bfe0d0f01430e4dbaad45e7ddddf0a9fc97317f90dbc51f7b0d9e1b5d.jpg",
      "bytes": 666655,
      "served": true,
      "licence": "CC0-1.0",
      "worlds": [
        "beach",
        "forest",
        "meadow",
        "polder",
        "villa",
        "volcanic-island"
      ],
      "width": 1024,
      "height": 1024,
      "averageColour": "#726124"
    },
    {
      "id": "aerial_rocks_02_diff_1k.jpg",
      "provider": "polyhaven",
      "asset": "aerial_rocks_02",
      "kind": "texture",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Textures/jpg/1k/aerial_rocks_02/aerial_rocks_02_diff_1k.jpg",
      "md5": "b5795e9b9e43d718ace73448c97d57ab",
      "sourceSha256": "708373b2af7fd07ac8de1500556006aaf904c41a99985a849cacc78874f38eac",
      "stored": "708373b2af7fd07ac8de1500556006aaf904c41a99985a849cacc78874f38eac.jpg",
      "bytes": 785923,
      "served": true,
      "licence": "CC0-1.0",
      "worlds": [
        "sea-floor",
        "volcanic-island"
      ],
      "width": 1024,
      "height": 1024,
      "averageColour": "#6e5c34"
    },
    {
      "id": "aerial_rocks_02_nor_gl_1k.jpg",
      "provider": "polyhaven",
      "asset": "aerial_rocks_02",
      "kind": "texture",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Textures/jpg/1k/aerial_rocks_02/aerial_rocks_02_nor_gl_1k.jpg",
      "md5": "66fcad0f6a7c2ac99bc978685195420b",
      "sourceSha256": "6df5263ba6c30e9343ee324d87078b926024d710b0b349025083600369df8d25",
      "stored": "6df5263ba6c30e9343ee324d87078b926024d710b0b349025083600369df8d25.jpg",
      "bytes": 1177932,
      "served": true,
      "licence": "CC0-1.0",
      "worlds": [
        "sea-floor",
        "volcanic-island"
      ],
      "width": 1024,
      "height": 1024,
      "averageColour": "#8481ef"
    },
    {
      "id": "amsterdam-street-loop.ogg",
      "provider": "freesound",
      "asset": "amsterdam-street",
      "kind": "audio",
      "sound": "Amsterdam city centre 3 amb, trams traffic people, Spui",
      "user": "eruk",
      "page": "https://freesound.org/people/eruk/sounds/259740/",
      "licence": "CC0-1.0",
      "worlds": [
        "modern-street"
      ],
      "sourceUrl": "https://cdn.freesound.org/previews/259/259740_99-hq.ogg",
      "derivedFrom": "259740_99-hq.ogg",
      "sha256": "18bdb3a13985275443fac745b983e14a5f8d9b5a5ae56f2693532e9a64f4d2e5",
      "stored": "18bdb3a13985275443fac745b983e14a5f8d9b5a5ae56f2693532e9a64f4d2e5.ogg",
      "bytes": 237322,
      "served": true,
      "seconds": 45,
      "channels": 1,
      "sampleRate": 48000,
      "from": 0,
      "gainDb": -1.5,
      "lufs": -24.66,
      "truePeak": -6.2,
      "loop": true
    },
    {
      "id": "asphalt_02_arm_1k.jpg",
      "provider": "polyhaven",
      "asset": "asphalt_02",
      "kind": "texture",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Textures/jpg/1k/asphalt_02/asphalt_02_arm_1k.jpg",
      "md5": "33820445f43af5e5ee484674b6939271",
      "sourceSha256": "56bd8e591a3db579846fcb5185f60b0651e0bd4ea85c3529c339e6746243c9cf",
      "stored": "56bd8e591a3db579846fcb5185f60b0651e0bd4ea85c3529c339e6746243c9cf.jpg",
      "bytes": 296770,
      "served": true,
      "licence": "CC0-1.0",
      "worlds": [
        "modern-street"
      ],
      "width": 1024,
      "height": 1024,
      "averageColour": "#b8c403"
    },
    {
      "id": "asphalt_02_diff_1k.jpg",
      "provider": "polyhaven",
      "asset": "asphalt_02",
      "kind": "texture",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Textures/jpg/1k/asphalt_02/asphalt_02_diff_1k.jpg",
      "md5": "fa19772d4817754c3efab708c651f5a8",
      "sourceSha256": "1aa5ce99f58a625c71d48cfc3e68b65ca85ccb00f39e045c0a928608a0ea25ed",
      "stored": "1aa5ce99f58a625c71d48cfc3e68b65ca85ccb00f39e045c0a928608a0ea25ed.jpg",
      "bytes": 731707,
      "served": true,
      "licence": "CC0-1.0",
      "worlds": [
        "modern-street"
      ],
      "width": 1024,
      "height": 1024,
      "averageColour": "#5a5a55"
    },
    {
      "id": "asphalt_02_nor_gl_1k.jpg",
      "provider": "polyhaven",
      "asset": "asphalt_02",
      "kind": "texture",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Textures/jpg/1k/asphalt_02/asphalt_02_nor_gl_1k.jpg",
      "md5": "338da8de636ea36133170578cac82e8e",
      "sourceSha256": "42a1c381b53204e83a982db2864479a30bc127bbdeebb1006f8ee51bff099df3",
      "stored": "42a1c381b53204e83a982db2864479a30bc127bbdeebb1006f8ee51bff099df3.jpg",
      "bytes": 1240122,
      "served": true,
      "licence": "CC0-1.0",
      "worlds": [
        "modern-street"
      ],
      "width": 1024,
      "height": 1024,
      "averageColour": "#7f7ff8"
    },
    {
      "id": "bunsen_burner.bin",
      "provider": "polyhaven",
      "asset": "bunsen_burner",
      "kind": "bin",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/gltf/4k/bunsen_burner/bunsen_burner.bin",
      "md5": "b0c62ffca9e4c995429d8b76111c0c46",
      "sourceSha256": "088fb944f12617341aa521359e1655df10d07643b584ee6dc808eb3df01a6e06",
      "stored": "088fb944f12617341aa521359e1655df10d07643b584ee6dc808eb3df01a6e06.bin",
      "bytes": 268876,
      "served": true,
      "licence": "CC0-1.0",
      "worlds": [
        "museum-hall",
        "science-lab"
      ]
    },
    {
      "id": "bunsen_burner.gltf",
      "provider": "polyhaven",
      "asset": "bunsen_burner",
      "kind": "gltf",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/gltf/1k/bunsen_burner/bunsen_burner_1k.gltf",
      "derivedFrom": "bunsen_burner_1k.gltf",
      "sha256": "3f8325dea0d96eb8b8a169600f66387b030a70203192d69b1f71dc9abf7dd04f",
      "stored": "3f8325dea0d96eb8b8a169600f66387b030a70203192d69b1f71dc9abf7dd04f.gltf",
      "bytes": 2657,
      "served": true,
      "licence": "CC0-1.0",
      "worlds": [
        "museum-hall",
        "science-lab"
      ],
      "triangles": 8434,
      "primitives": 2,
      "materials": 1,
      "bounds": {
        "min": [
          -0.0694,
          0,
          -0.0694
        ],
        "max": [
          0.0694,
          0.1731,
          0.0694
        ]
      },
      "requires": [
        "088fb944f12617341aa521359e1655df10d07643b584ee6dc808eb3df01a6e06.bin",
        "28d8a856df12b8348d28afaabd3b1863c3c1fdf535d118025b88db5c815365b9.jpg",
        "476a36d6534516e008ec37e6e465b4a28cf88a6df20a0755bdc49960287e3f1f.jpg",
        "b1b0332ef082607f22f15f2bb5f9af2e4996f5b9aa2b8924228d8142edfe79c6.jpg"
      ],
      "resizedTo": 512
    },
    {
      "id": "bunsen_burner_1k.gltf",
      "provider": "polyhaven",
      "asset": "bunsen_burner",
      "kind": "gltf",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/gltf/1k/bunsen_burner/bunsen_burner_1k.gltf",
      "md5": "f3445637eac771cdd1f41765b1f018ea",
      "sourceSha256": "7c65775950cc7070513c4ce96d3d5f0035a3be5086f83cdba651a0ffc03b8a73",
      "stored": "7c65775950cc7070513c4ce96d3d5f0035a3be5086f83cdba651a0ffc03b8a73.gltf",
      "bytes": 4182,
      "served": false,
      "licence": "CC0-1.0",
      "worlds": [
        "science-lab"
      ],
      "triangles": 8434,
      "primitives": 2,
      "materials": 1,
      "bounds": {
        "min": [
          -0.0694,
          0,
          -0.0694
        ],
        "max": [
          0.0694,
          0.1731,
          0.0694
        ]
      }
    },
    {
      "id": "bunsen_burner_arm_1k.jpg",
      "provider": "polyhaven",
      "asset": "bunsen_burner",
      "kind": "texture",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/jpg/1k/bunsen_burner/bunsen_burner_arm_1k.jpg",
      "md5": "0698b549645a5683d18bac35b449fe82",
      "sourceSha256": "5d6cb8b08cefa4588f778fd843ad7cfd97246d3919e447b6213f9356f59dfa4c",
      "stored": "5d6cb8b08cefa4588f778fd843ad7cfd97246d3919e447b6213f9356f59dfa4c.jpg",
      "bytes": 803757,
      "served": false,
      "licence": "CC0-1.0",
      "worlds": [
        "science-lab"
      ],
      "width": 1024,
      "height": 1024,
      "averageColour": "#b48253"
    },
    {
      "id": "bunsen_burner_arm_512.jpg",
      "provider": "polyhaven",
      "asset": "bunsen_burner",
      "kind": "texture",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/jpg/1k/bunsen_burner/bunsen_burner_arm_1k.jpg",
      "derivedFrom": "bunsen_burner_arm_1k.jpg",
      "sha256": "28d8a856df12b8348d28afaabd3b1863c3c1fdf535d118025b88db5c815365b9",
      "stored": "28d8a856df12b8348d28afaabd3b1863c3c1fdf535d118025b88db5c815365b9.jpg",
      "bytes": 64000,
      "served": true,
      "licence": "CC0-1.0",
      "worlds": [
        "museum-hall",
        "science-lab"
      ],
      "width": 512,
      "height": 512,
      "averageColour": "#b48254"
    },
    {
      "id": "bunsen_burner_diff_1k.jpg",
      "provider": "polyhaven",
      "asset": "bunsen_burner",
      "kind": "texture",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/jpg/1k/bunsen_burner/bunsen_burner_diff_1k.jpg",
      "md5": "9c99a5d0a8824dbb67a4d6cb5eb36531",
      "sourceSha256": "fd12b3ef7c6904b1675e26f15bb06acddefb8aa380a0a151f59cf1b1f6f3a474",
      "stored": "fd12b3ef7c6904b1675e26f15bb06acddefb8aa380a0a151f59cf1b1f6f3a474.jpg",
      "bytes": 532526,
      "served": false,
      "licence": "CC0-1.0",
      "worlds": [
        "science-lab"
      ],
      "width": 1024,
      "height": 1024,
      "averageColour": "#575581"
    },
    {
      "id": "bunsen_burner_diff_512.jpg",
      "provider": "polyhaven",
      "asset": "bunsen_burner",
      "kind": "texture",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/jpg/1k/bunsen_burner/bunsen_burner_diff_1k.jpg",
      "derivedFrom": "bunsen_burner_diff_1k.jpg",
      "sha256": "b1b0332ef082607f22f15f2bb5f9af2e4996f5b9aa2b8924228d8142edfe79c6",
      "stored": "b1b0332ef082607f22f15f2bb5f9af2e4996f5b9aa2b8924228d8142edfe79c6.jpg",
      "bytes": 42343,
      "served": true,
      "licence": "CC0-1.0",
      "worlds": [
        "museum-hall",
        "science-lab"
      ],
      "width": 512,
      "height": 512,
      "averageColour": "#575581"
    },
    {
      "id": "bunsen_burner_nor_gl_1k.jpg",
      "provider": "polyhaven",
      "asset": "bunsen_burner",
      "kind": "texture",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/jpg/1k/bunsen_burner/bunsen_burner_nor_gl_1k.jpg",
      "md5": "2c6e727f64d64a5b87cf34638252f450",
      "sourceSha256": "2b02cefc52e30c8f6d946f9f804e87d2b33dbb4a42499f22956f48283491a5f8",
      "stored": "2b02cefc52e30c8f6d946f9f804e87d2b33dbb4a42499f22956f48283491a5f8.jpg",
      "bytes": 524169,
      "served": false,
      "licence": "CC0-1.0",
      "worlds": [
        "science-lab"
      ],
      "width": 1024,
      "height": 1024,
      "averageColour": "#8280f9"
    },
    {
      "id": "bunsen_burner_nor_gl_512.jpg",
      "provider": "polyhaven",
      "asset": "bunsen_burner",
      "kind": "texture",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/jpg/1k/bunsen_burner/bunsen_burner_nor_gl_1k.jpg",
      "derivedFrom": "bunsen_burner_nor_gl_1k.jpg",
      "sha256": "476a36d6534516e008ec37e6e465b4a28cf88a6df20a0755bdc49960287e3f1f",
      "stored": "476a36d6534516e008ec37e6e465b4a28cf88a6df20a0755bdc49960287e3f1f.jpg",
      "bytes": 32422,
      "served": true,
      "licence": "CC0-1.0",
      "worlds": [
        "museum-hall",
        "science-lab"
      ],
      "width": 512,
      "height": 512,
      "averageColour": "#8280f9"
    },
    {
      "id": "chemistry_set.bin",
      "provider": "polyhaven",
      "asset": "chemistry_set",
      "kind": "bin",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/gltf/4k/chemistry_set/chemistry_set.bin",
      "md5": "dd34add16eb9457ffc127104f14883d9",
      "sourceSha256": "59c3a8adb8b77f7ecb1ce001f7d7663e5fd0f567d9fcec9006a68a56fce4cf2a",
      "stored": "59c3a8adb8b77f7ecb1ce001f7d7663e5fd0f567d9fcec9006a68a56fce4cf2a.bin",
      "bytes": 1181556,
      "served": true,
      "licence": "CC0-1.0",
      "worlds": [
        "museum-hall",
        "science-lab"
      ]
    },
    {
      "id": "chemistry_set.gltf",
      "provider": "polyhaven",
      "asset": "chemistry_set",
      "kind": "gltf",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/gltf/1k/chemistry_set/chemistry_set_1k.gltf",
      "derivedFrom": "chemistry_set_1k.gltf",
      "sha256": "7223f44f961a43dec6861edafe18e6c92c02f51c0e66800ddb8adac59b2728b9",
      "stored": "7223f44f961a43dec6861edafe18e6c92c02f51c0e66800ddb8adac59b2728b9.gltf",
      "bytes": 47112,
      "served": true,
      "licence": "CC0-1.0",
      "worlds": [
        "museum-hall",
        "science-lab"
      ],
      "triangles": 41958,
      "primitives": 52,
      "materials": 2,
      "bounds": {
        "min": [
          -0.5248,
          -0.009,
          -0.2289
        ],
        "max": [
          0.5536,
          0.42,
          0.125
        ]
      },
      "requires": [
        "59c3a8adb8b77f7ecb1ce001f7d7663e5fd0f567d9fcec9006a68a56fce4cf2a.bin",
        "8bccb3f526b30a60e46981ed8ea8cf40b6af40b0fde1f3c9b3f5a7e36579e0e8.jpg",
        "cca7d3b4c30e8d0563934b59e0600e9659ce6c546b77705ca87c7ae5ffd3fd7a.jpg",
        "cf013f7898f70e1479b1b0fe774668b24cc7718983a9c7bb5eaa1670b0088b4b.jpg"
      ]
    },
    {
      "id": "chemistry_set_1k.gltf",
      "provider": "polyhaven",
      "asset": "chemistry_set",
      "kind": "gltf",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/gltf/1k/chemistry_set/chemistry_set_1k.gltf",
      "md5": "05a89ca960a430766ec4c3e1fdf10e79",
      "sourceSha256": "e02dd6433880fd3dfab82b254a6fe909c38d5a8be184b5b21004d231c11991b6",
      "stored": "e02dd6433880fd3dfab82b254a6fe909c38d5a8be184b5b21004d231c11991b6.gltf",
      "bytes": 79977,
      "served": false,
      "licence": "CC0-1.0",
      "worlds": [
        "science-lab"
      ],
      "triangles": 41958,
      "primitives": 52,
      "materials": 2,
      "bounds": {
        "min": [
          -0.5248,
          -0.009,
          -0.2289
        ],
        "max": [
          0.5536,
          0.42,
          0.125
        ]
      }
    },
    {
      "id": "chemistry_set_arm_1k.jpg",
      "provider": "polyhaven",
      "asset": "chemistry_set",
      "kind": "texture",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/jpg/1k/chemistry_set/chemistry_set_arm_1k.jpg",
      "md5": "95cbb6982e288a69375ef99083908e40",
      "sourceSha256": "cca7d3b4c30e8d0563934b59e0600e9659ce6c546b77705ca87c7ae5ffd3fd7a",
      "stored": "cca7d3b4c30e8d0563934b59e0600e9659ce6c546b77705ca87c7ae5ffd3fd7a.jpg",
      "bytes": 950518,
      "served": true,
      "licence": "CC0-1.0",
      "worlds": [
        "museum-hall",
        "science-lab"
      ],
      "width": 1024,
      "height": 1024,
      "averageColour": "#9b3fcd"
    },
    {
      "id": "chemistry_set_diff_1k.jpg",
      "provider": "polyhaven",
      "asset": "chemistry_set",
      "kind": "texture",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/jpg/1k/chemistry_set/chemistry_set_diff_1k.jpg",
      "md5": "a93571004c8974d96093010561128bbe",
      "sourceSha256": "cf013f7898f70e1479b1b0fe774668b24cc7718983a9c7bb5eaa1670b0088b4b",
      "stored": "cf013f7898f70e1479b1b0fe774668b24cc7718983a9c7bb5eaa1670b0088b4b.jpg",
      "bytes": 553332,
      "served": true,
      "licence": "CC0-1.0",
      "worlds": [
        "museum-hall",
        "science-lab"
      ],
      "width": 1024,
      "height": 1024,
      "averageColour": "#63605b"
    },
    {
      "id": "chemistry_set_nor_gl_1k.jpg",
      "provider": "polyhaven",
      "asset": "chemistry_set",
      "kind": "texture",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/jpg/1k/chemistry_set/chemistry_set_nor_gl_1k.jpg",
      "md5": "bd280566cdfd32c4c106f9f734987df7",
      "sourceSha256": "8bccb3f526b30a60e46981ed8ea8cf40b6af40b0fde1f3c9b3f5a7e36579e0e8",
      "stored": "8bccb3f526b30a60e46981ed8ea8cf40b6af40b0fde1f3c9b3f5a7e36579e0e8.jpg",
      "bytes": 440776,
      "served": true,
      "licence": "CC0-1.0",
      "worlds": [
        "museum-hall",
        "science-lab"
      ],
      "width": 1024,
      "height": 1024,
      "averageColour": "#807ffd"
    },
    {
      "id": "coast_sand_01_diff_1k.jpg",
      "provider": "polyhaven",
      "asset": "coast_sand_01",
      "kind": "texture",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Textures/jpg/1k/coast_sand_01/coast_sand_01_diff_1k.jpg",
      "md5": "a1e243fc8635806381505c7dc44b192a",
      "sourceSha256": "58af2e40100f7f405703a86d593af64379f822c4786850def23ecfc921450d54",
      "stored": "58af2e40100f7f405703a86d593af64379f822c4786850def23ecfc921450d54.jpg",
      "bytes": 960614,
      "served": true,
      "licence": "CC0-1.0",
      "worlds": [
        "beach",
        "sea-floor",
        "villa",
        "volcanic-island"
      ],
      "width": 1024,
      "height": 1024,
      "averageColour": "#82725b"
    },
    {
      "id": "coast_sand_01_nor_gl_1k.jpg",
      "provider": "polyhaven",
      "asset": "coast_sand_01",
      "kind": "texture",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Textures/jpg/1k/coast_sand_01/coast_sand_01_nor_gl_1k.jpg",
      "md5": "38bbe6863249a3d20d8417c9db207780",
      "sourceSha256": "fe4d045aec99e71e80f682fcf0ad958d2dff1fe614b73178b304d1bac047b54a",
      "stored": "fe4d045aec99e71e80f682fcf0ad958d2dff1fe614b73178b304d1bac047b54a.jpg",
      "bytes": 1146826,
      "served": true,
      "licence": "CC0-1.0",
      "worlds": [
        "beach",
        "sea-floor",
        "villa",
        "volcanic-island"
      ],
      "width": 1024,
      "height": 1024,
      "averageColour": "#8080f7"
    },
    {
      "id": "crystalline_iceplant.bin",
      "provider": "polyhaven",
      "asset": "crystalline_iceplant",
      "kind": "bin",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/gltf/8k/crystalline_iceplant/crystalline_iceplant.bin",
      "md5": "4074e1d087458162c160b8312163acea",
      "sourceSha256": "f51b43e9235e1765eb44495edf4f68e53c693a4ea1bab93830ac2e9f8e0d183a",
      "stored": "f51b43e9235e1765eb44495edf4f68e53c693a4ea1bab93830ac2e9f8e0d183a.bin",
      "bytes": 330436,
      "served": false,
      "licence": "CC0-1.0",
      "worlds": [
        "volcanic-island"
      ]
    },
    {
      "id": "crystalline_iceplant.gltf",
      "provider": "polyhaven",
      "asset": "crystalline_iceplant",
      "kind": "gltf",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/gltf/1k/crystalline_iceplant/crystalline_iceplant_1k.gltf",
      "derivedFrom": "crystalline_iceplant_1k.gltf",
      "sha256": "ca68a93bf1ea3d853c6ae4e8305172c81152cadead91f710c438588d93ffa4b9",
      "stored": "ca68a93bf1ea3d853c6ae4e8305172c81152cadead91f710c438588d93ffa4b9.gltf",
      "bytes": 6882,
      "served": true,
      "licence": "CC0-1.0",
      "worlds": [
        "volcanic-island"
      ],
      "triangles": 1993,
      "primitives": 8,
      "materials": 1,
      "bounds": {
        "min": [
          -0.8011,
          -0.0035,
          -0.4324
        ],
        "max": [
          0.8924,
          0.0787,
          0.3055
        ]
      },
      "requires": [
        "664d9a053774f15eb1305d83670e0fb4cc253f46d50ba7ea435585b65e4f5920.bin",
        "b66729fa03bf68c3f7520bf333b50fc9a18f18adad1afda182cad42d2c6ce371.jpg"
      ],
      "simplifiedFrom": 13094,
      "variants": [
        {
          "name": "crystalline_iceplant_a_LOD0",
          "triangles": 468,
          "size": [
            0.276,
            0.081,
            0.316
          ]
        },
        {
          "name": "crystalline_iceplant_b_LOD0",
          "triangles": 392,
          "size": [
            0.28,
            0.065,
            0.306
          ]
        },
        {
          "name": "crystalline_iceplant_c_LOD0",
          "triangles": 351,
          "size": [
            0.267,
            0.061,
            0.227
          ]
        },
        {
          "name": "crystalline_iceplant_d_LOD0",
          "triangles": 288,
          "size": [
            0.144,
            0.038,
            0.183
          ]
        },
        {
          "name": "crystalline_iceplant_e_LOD0",
          "triangles": 207,
          "size": [
            0.153,
            0.029,
            0.112
          ]
        },
        {
          "name": "crystalline_iceplant_f_LOD0",
          "triangles": 129,
          "size": [
            0.111,
            0.027,
            0.088
          ]
        },
        {
          "name": "crystalline_iceplant_g_LOD0",
          "triangles": 90,
          "size": [
            0.108,
            0.029,
            0.092
          ]
        },
        {
          "name": "crystalline_iceplant_h_LOD0",
          "triangles": 68,
          "size": [
            0.054,
            0.016,
            0.059
          ]
        }
      ],
      "resizedTo": 512
    },
    {
      "id": "crystalline_iceplant_1k.gltf",
      "provider": "polyhaven",
      "asset": "crystalline_iceplant",
      "kind": "gltf",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/gltf/1k/crystalline_iceplant/crystalline_iceplant_1k.gltf",
      "md5": "290f5e514fcdd5205642c04d065aa286",
      "sourceSha256": "46983341146dfacc96116e7468562b9e3b0a5be15d15940a98d9bab045c39910",
      "stored": "46983341146dfacc96116e7468562b9e3b0a5be15d15940a98d9bab045c39910.gltf",
      "bytes": 13607,
      "served": false,
      "licence": "CC0-1.0",
      "worlds": [
        "volcanic-island"
      ],
      "triangles": 13094,
      "primitives": 8,
      "materials": 1,
      "bounds": {
        "min": [
          -0.8011,
          -0.0035,
          -0.4324
        ],
        "max": [
          0.8924,
          0.0787,
          0.3055
        ]
      }
    },
    {
      "id": "crystalline_iceplant_alpha_1k.png",
      "provider": "polyhaven",
      "asset": "crystalline_iceplant",
      "kind": "texture",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/png/1k/crystalline_iceplant/crystalline_iceplant_alpha_1k.png",
      "md5": "20316c7701d2adf902db649f4045f64d",
      "sourceSha256": "bbffe8f1a6920f2613d416aee3be47a803211fd740e8f7b354194db8db91f6fb",
      "stored": "bbffe8f1a6920f2613d416aee3be47a803211fd740e8f7b354194db8db91f6fb.png",
      "bytes": 37709,
      "served": false,
      "licence": "CC0-1.0",
      "worlds": [
        "volcanic-island"
      ],
      "width": 1024,
      "height": 1024,
      "averageColour": "#9317"
    },
    {
      "id": "crystalline_iceplant_diff_1k.jpg",
      "provider": "polyhaven",
      "asset": "crystalline_iceplant",
      "kind": "texture",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/jpg/1k/crystalline_iceplant/crystalline_iceplant_diff_1k.jpg",
      "md5": "bf5b424efbb8c19ab158a565e5f51bd6",
      "sourceSha256": "bf191d9f2f903961c45b16d9bee0efa4cf8a64dc66f98159d91ba9699f61db8f",
      "stored": "bf191d9f2f903961c45b16d9bee0efa4cf8a64dc66f98159d91ba9699f61db8f.jpg",
      "bytes": 510658,
      "served": false,
      "licence": "CC0-1.0",
      "worlds": [
        "volcanic-island"
      ],
      "width": 1024,
      "height": 1024,
      "averageColour": "#3e3b1b"
    },
    {
      "id": "crystalline_iceplant_diff_512.png",
      "provider": "polyhaven",
      "asset": "crystalline_iceplant",
      "kind": "texture",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/jpg/1k/crystalline_iceplant/crystalline_iceplant_diff_1k.jpg",
      "derivedFrom": "crystalline_iceplant_diff_1k.jpg",
      "sha256": "b66729fa03bf68c3f7520bf333b50fc9a18f18adad1afda182cad42d2c6ce371",
      "stored": "b66729fa03bf68c3f7520bf333b50fc9a18f18adad1afda182cad42d2c6ce371.jpg",
      "bytes": 415420,
      "served": true,
      "licence": "CC0-1.0",
      "worlds": [
        "volcanic-island"
      ],
      "width": 512,
      "height": 512,
      "averageColour": "#3e3b1c"
    },
    {
      "id": "crystalline_iceplant_simplified.bin",
      "provider": "polyhaven",
      "asset": "crystalline_iceplant",
      "kind": "bin",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/gltf/8k/crystalline_iceplant/crystalline_iceplant.bin",
      "derivedFrom": "crystalline_iceplant.bin",
      "sha256": "664d9a053774f15eb1305d83670e0fb4cc253f46d50ba7ea435585b65e4f5920",
      "stored": "664d9a053774f15eb1305d83670e0fb4cc253f46d50ba7ea435585b65e4f5920.bin",
      "bytes": 62780,
      "served": true,
      "licence": "CC0-1.0",
      "worlds": [
        "volcanic-island"
      ]
    },
    {
      "id": "dead_quiver_trunk.bin",
      "provider": "polyhaven",
      "asset": "dead_quiver_trunk",
      "kind": "bin",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/gltf/8k/dead_quiver_trunk/dead_quiver_trunk.bin",
      "md5": "14020d9d6b8a6303ef0c4204f3aecf39",
      "sourceSha256": "2f2a74458c071801cde2287970a396d503ffe0ebf4dedc3c5f3b39024186c00a",
      "stored": "2f2a74458c071801cde2287970a396d503ffe0ebf4dedc3c5f3b39024186c00a.bin",
      "bytes": 411388,
      "served": false,
      "licence": "CC0-1.0",
      "worlds": [
        "volcanic-island"
      ]
    },
    {
      "id": "dead_quiver_trunk.gltf",
      "provider": "polyhaven",
      "asset": "dead_quiver_trunk",
      "kind": "gltf",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/gltf/1k/dead_quiver_trunk/dead_quiver_trunk_1k.gltf",
      "derivedFrom": "dead_quiver_trunk_1k.gltf",
      "sha256": "7932c9d6cf0dfc0e30800ca68bdf071a221f4e031158e576c93dcc8de5a1fa4f",
      "stored": "7932c9d6cf0dfc0e30800ca68bdf071a221f4e031158e576c93dcc8de5a1fa4f.gltf",
      "bytes": 1452,
      "served": true,
      "licence": "CC0-1.0",
      "worlds": [],
      "triangles": 1994,
      "primitives": 1,
      "materials": 1,
      "bounds": {
        "min": [
          -0.1705,
          0.0118,
          -0.1311
        ],
        "max": [
          0.1348,
          2.0052,
          0.137
        ]
      },
      "requires": [
        "c42f986f3aeefdd4558aff638f1b4ae7ab29501d9bc588cd4019076b7e91e887.bin",
        "ce359b12f7cec564474e5a42384b93e89135e054f11ffc9f201b059efdec08a9.jpg"
      ],
      "simplifiedFrom": 17978,
      "variants": [
        {
          "name": "dead_quiver_trunk_LOD0",
          "triangles": 1994,
          "size": [
            0.305,
            1.993,
            0.268
          ]
        }
      ],
      "resizedTo": 512
    },
    {
      "id": "dead_quiver_trunk_1k.gltf",
      "provider": "polyhaven",
      "asset": "dead_quiver_trunk",
      "kind": "gltf",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/gltf/1k/dead_quiver_trunk/dead_quiver_trunk_1k.gltf",
      "md5": "c51327370de65114dbab13686deb3f07",
      "sourceSha256": "c130bce552d608057143e7f131f36e9c4e06a9b780947c85d4e5eb1cacfedbaf",
      "stored": "c130bce552d608057143e7f131f36e9c4e06a9b780947c85d4e5eb1cacfedbaf.gltf",
      "bytes": 2833,
      "served": false,
      "licence": "CC0-1.0",
      "worlds": [
        "volcanic-island"
      ],
      "triangles": 17978,
      "primitives": 1,
      "materials": 1,
      "bounds": {
        "min": [
          -0.1705,
          0.0118,
          -0.1311
        ],
        "max": [
          0.136,
          2.0059,
          0.137
        ]
      }
    },
    {
      "id": "dead_quiver_trunk_diff_1k.jpg",
      "provider": "polyhaven",
      "asset": "dead_quiver_trunk",
      "kind": "texture",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/jpg/1k/dead_quiver_trunk/dead_quiver_trunk_diff_1k.jpg",
      "md5": "e9348ba90e390c46d9d6837cf0425d4b",
      "sourceSha256": "53015f7dc3cc9a5ad360439b63c72d90402314201255495684bf6a6499aef7e0",
      "stored": "53015f7dc3cc9a5ad360439b63c72d90402314201255495684bf6a6499aef7e0.jpg",
      "bytes": 768713,
      "served": false,
      "licence": "CC0-1.0",
      "worlds": [
        "volcanic-island"
      ],
      "width": 1024,
      "height": 1024,
      "averageColour": "#9a948d"
    },
    {
      "id": "dead_quiver_trunk_diff_512.jpg",
      "provider": "polyhaven",
      "asset": "dead_quiver_trunk",
      "kind": "texture",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/jpg/1k/dead_quiver_trunk/dead_quiver_trunk_diff_1k.jpg",
      "derivedFrom": "dead_quiver_trunk_diff_1k.jpg",
      "sha256": "ce359b12f7cec564474e5a42384b93e89135e054f11ffc9f201b059efdec08a9",
      "stored": "ce359b12f7cec564474e5a42384b93e89135e054f11ffc9f201b059efdec08a9.jpg",
      "bytes": 61567,
      "served": true,
      "licence": "CC0-1.0",
      "worlds": [],
      "width": 512,
      "height": 512,
      "averageColour": "#9a948d"
    },
    {
      "id": "dead_quiver_trunk_simplified.bin",
      "provider": "polyhaven",
      "asset": "dead_quiver_trunk",
      "kind": "bin",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/gltf/8k/dead_quiver_trunk/dead_quiver_trunk.bin",
      "derivedFrom": "dead_quiver_trunk.bin",
      "sha256": "c42f986f3aeefdd4558aff638f1b4ae7ab29501d9bc588cd4019076b7e91e887",
      "stored": "c42f986f3aeefdd4558aff638f1b4ae7ab29501d9bc588cd4019076b7e91e887.bin",
      "bytes": 52476,
      "served": true,
      "licence": "CC0-1.0",
      "worlds": []
    },
    {
      "id": "fern_02.bin",
      "provider": "polyhaven",
      "asset": "fern_02",
      "kind": "bin",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/gltf/8k/fern_02/fern_02.bin",
      "md5": "c061e9255f7d36ae9ce0e92ef3e100b2",
      "sourceSha256": "fe1abb762bcbbc7ad9e86925c8080437a62add257d9280e9142fdc85c226e64c",
      "stored": "fe1abb762bcbbc7ad9e86925c8080437a62add257d9280e9142fdc85c226e64c.bin",
      "bytes": 176176,
      "served": false,
      "licence": "CC0-1.0",
      "worlds": [
        "volcanic-island"
      ]
    },
    {
      "id": "fern_02.gltf",
      "provider": "polyhaven",
      "asset": "fern_02",
      "kind": "gltf",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/gltf/1k/fern_02/fern_02_1k.gltf",
      "derivedFrom": "fern_02_1k.gltf",
      "sha256": "2a0840e3207fad98a1a9162ee68c3c23044155733caec0a66cb5a0becedfdd2e",
      "stored": "2a0840e3207fad98a1a9162ee68c3c23044155733caec0a66cb5a0becedfdd2e.gltf",
      "bytes": 3683,
      "served": true,
      "licence": "CC0-1.0",
      "worlds": [
        "forest",
        "volcanic-island"
      ],
      "triangles": 1995,
      "primitives": 4,
      "materials": 1,
      "bounds": {
        "min": [
          -0.5281,
          -0.0305,
          -0.4219
        ],
        "max": [
          1.4429,
          0.3972,
          1.3022
        ]
      },
      "requires": [
        "77b78aaccb9ba8e20108d03bb074bc9f3845e3975e12d5c603a2d8288d58dd31.jpg",
        "c9e7667f2271c27c3cf7318c5961cbfd13a8111776d600158216129ff625d1e3.bin"
      ],
      "simplifiedFrom": 6232,
      "variants": [
        {
          "name": "fern_02_b",
          "triangles": 765,
          "size": [
            0.989,
            0.428,
            0.894
          ]
        },
        {
          "name": "fern_02_c",
          "triangles": 720,
          "size": [
            0.873,
            0.349,
            0.75
          ]
        },
        {
          "name": "fern_02_a",
          "triangles": 250,
          "size": [
            0.552,
            0.287,
            0.614
          ]
        },
        {
          "name": "fern_02_d",
          "triangles": 260,
          "size": [
            0.573,
            0.213,
            0.593
          ]
        }
      ],
      "resizedTo": 512
    },
    {
      "id": "fern_02_1k.gltf",
      "provider": "polyhaven",
      "asset": "fern_02",
      "kind": "gltf",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/gltf/1k/fern_02/fern_02_1k.gltf",
      "md5": "cf276874d37bfb73c299504a6b355b77",
      "sourceSha256": "33974295ee19670af4877705fc7d91f33f42d6302f0d44a625e072271223031f",
      "stored": "33974295ee19670af4877705fc7d91f33f42d6302f0d44a625e072271223031f.gltf",
      "bytes": 6899,
      "served": false,
      "licence": "CC0-1.0",
      "worlds": [
        "volcanic-island"
      ],
      "triangles": 6232,
      "primitives": 4,
      "materials": 1,
      "bounds": {
        "min": [
          -0.5281,
          -0.0305,
          -0.4219
        ],
        "max": [
          1.4444,
          0.3972,
          1.3022
        ]
      }
    },
    {
      "id": "fern_02_alpha_1k.png",
      "provider": "polyhaven",
      "asset": "fern_02",
      "kind": "texture",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/png/1k/fern_02/fern_02_alpha_1k.png",
      "md5": "1421e5e36946c23a7ddcc907de89025c",
      "sourceSha256": "ea3c64284c7ebdeedf484d2d816eae92825ec526140c3bb83859ddc7a64001f9",
      "stored": "ea3c64284c7ebdeedf484d2d816eae92825ec526140c3bb83859ddc7a64001f9.png",
      "bytes": 114589,
      "served": false,
      "licence": "CC0-1.0",
      "worlds": [
        "volcanic-island"
      ],
      "width": 1024,
      "height": 1024,
      "averageColour": "#2767"
    },
    {
      "id": "fern_02_diff_1k.jpg",
      "provider": "polyhaven",
      "asset": "fern_02",
      "kind": "texture",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/jpg/1k/fern_02/fern_02_diff_1k.jpg",
      "md5": "82c18a6cfd5ae91c37c0e078f591181c",
      "sourceSha256": "a828a6e7b4c01c826911e2eac4b3afc7457dab7b3b392a31c681ed88b7d50029",
      "stored": "a828a6e7b4c01c826911e2eac4b3afc7457dab7b3b392a31c681ed88b7d50029.jpg",
      "bytes": 315705,
      "served": false,
      "licence": "CC0-1.0",
      "worlds": [
        "volcanic-island"
      ],
      "width": 1024,
      "height": 1024,
      "averageColour": "#56622a"
    },
    {
      "id": "fern_02_diff_512.png",
      "provider": "polyhaven",
      "asset": "fern_02",
      "kind": "texture",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/jpg/1k/fern_02/fern_02_diff_1k.jpg",
      "derivedFrom": "fern_02_diff_1k.jpg",
      "sha256": "77b78aaccb9ba8e20108d03bb074bc9f3845e3975e12d5c603a2d8288d58dd31",
      "stored": "77b78aaccb9ba8e20108d03bb074bc9f3845e3975e12d5c603a2d8288d58dd31.jpg",
      "bytes": 380812,
      "served": true,
      "licence": "CC0-1.0",
      "worlds": [
        "forest",
        "volcanic-island"
      ],
      "width": 512,
      "height": 512,
      "averageColour": "#56622a"
    },
    {
      "id": "fern_02_simplified.bin",
      "provider": "polyhaven",
      "asset": "fern_02",
      "kind": "bin",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/gltf/8k/fern_02/fern_02.bin",
      "derivedFrom": "fern_02.bin",
      "sha256": "c9e7667f2271c27c3cf7318c5961cbfd13a8111776d600158216129ff625d1e3",
      "stored": "c9e7667f2271c27c3cf7318c5961cbfd13a8111776d600158216129ff625d1e3.bin",
      "bytes": 65316,
      "served": true,
      "licence": "CC0-1.0",
      "worlds": [
        "forest",
        "volcanic-island"
      ]
    },
    {
      "id": "floor_klinkers_01_arm_1k.jpg",
      "provider": "polyhaven",
      "asset": "floor_klinkers_01",
      "kind": "texture",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Textures/jpg/1k/floor_klinkers_01/floor_klinkers_01_arm_1k.jpg",
      "md5": "6765cfa9de7563cdb9f66ab06ce1fb03",
      "sourceSha256": "275f116638530e71bc2ff09ed24169ff115371397398d67f04d6676eb0dde4c9",
      "stored": "275f116638530e71bc2ff09ed24169ff115371397398d67f04d6676eb0dde4c9.jpg",
      "bytes": 419938,
      "served": true,
      "licence": "CC0-1.0",
      "worlds": [
        "town-square"
      ],
      "width": 1024,
      "height": 1024,
      "averageColour": "#caaa05"
    },
    {
      "id": "floor_klinkers_01_diff_1k.jpg",
      "provider": "polyhaven",
      "asset": "floor_klinkers_01",
      "kind": "texture",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Textures/jpg/1k/floor_klinkers_01/floor_klinkers_01_diff_1k.jpg",
      "md5": "286d54ccd8da90abf702de963da0b772",
      "sourceSha256": "468ae16654e092c5523604b8afa43b1dfb47dc322fb2bfb48bc18c33e5f815f8",
      "stored": "468ae16654e092c5523604b8afa43b1dfb47dc322fb2bfb48bc18c33e5f815f8.jpg",
      "bytes": 950011,
      "served": true,
      "licence": "CC0-1.0",
      "worlds": [
        "town-square"
      ],
      "width": 1024,
      "height": 1024,
      "averageColour": "#907c55"
    },
    {
      "id": "floor_klinkers_01_nor_gl_1k.jpg",
      "provider": "polyhaven",
      "asset": "floor_klinkers_01",
      "kind": "texture",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Textures/jpg/1k/floor_klinkers_01/floor_klinkers_01_nor_gl_1k.jpg",
      "md5": "d6941bef2cf7d5b5718eb39b27439348",
      "sourceSha256": "bee3c070a1df85895db5d8d75b3b5d219163388c9cd54878dcbd4660b4c7e318",
      "stored": "bee3c070a1df85895db5d8d75b3b5d219163388c9cd54878dcbd4660b4c7e318.jpg",
      "bytes": 884658,
      "served": true,
      "licence": "CC0-1.0",
      "worlds": [
        "town-square"
      ],
      "width": 1024,
      "height": 1024,
      "averageColour": "#797bf2"
    },
    {
      "id": "floor_tiles_06_arm_1k.jpg",
      "provider": "polyhaven",
      "asset": "floor_tiles_06",
      "kind": "texture",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Textures/jpg/1k/floor_tiles_06/floor_tiles_06_arm_1k.jpg",
      "md5": "313293cb07aca1d9c9c4cce85eeb794e",
      "sourceSha256": "c2f22a181363d4b64fbdbc57c65492eaeac1d09a761b1cbc00dfd4dfc72b003d",
      "stored": "c2f22a181363d4b64fbdbc57c65492eaeac1d09a761b1cbc00dfd4dfc72b003d.jpg",
      "bytes": 54871,
      "served": true,
      "licence": "CC0-1.0",
      "worlds": [
        "science-lab"
      ],
      "width": 1024,
      "height": 1024,
      "averageColour": "#f08101"
    },
    {
      "id": "floor_tiles_06_diff_1k.jpg",
      "provider": "polyhaven",
      "asset": "floor_tiles_06",
      "kind": "texture",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Textures/jpg/1k/floor_tiles_06/floor_tiles_06_diff_1k.jpg",
      "md5": "a911ad8dc31e4f49a7cf782a114f7aa6",
      "sourceSha256": "ac159ca6072e30dd9d5c65e2d6eae7bb55a7dc9f06e6d141e9119390563511c2",
      "stored": "ac159ca6072e30dd9d5c65e2d6eae7bb55a7dc9f06e6d141e9119390563511c2.jpg",
      "bytes": 356257,
      "served": true,
      "licence": "CC0-1.0",
      "worlds": [
        "science-lab",
        "villa"
      ],
      "width": 1024,
      "height": 1024,
      "averageColour": "#796f6b"
    },
    {
      "id": "floor_tiles_06_nor_gl_1k.jpg",
      "provider": "polyhaven",
      "asset": "floor_tiles_06",
      "kind": "texture",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Textures/jpg/1k/floor_tiles_06/floor_tiles_06_nor_gl_1k.jpg",
      "md5": "6089f05b33713ae6758d8301739fbc94",
      "sourceSha256": "efaff964d5688dd52ea3b876d5dac63ffee76d8d7270e30c11c81095246d5fdd",
      "stored": "efaff964d5688dd52ea3b876d5dac63ffee76d8d7270e30c11c81095246d5fdd.jpg",
      "bytes": 121299,
      "served": true,
      "licence": "CC0-1.0",
      "worlds": [
        "modern-street",
        "science-lab",
        "villa"
      ],
      "width": 1024,
      "height": 1024,
      "averageColour": "#8585ff"
    },
    {
      "id": "forest-birds-loop.ogg",
      "provider": "freesound",
      "asset": "forest-birds",
      "kind": "audio",
      "sound": "sfx_amb_forest_spring_afternoon-01",
      "user": "bajko",
      "page": "https://freesound.org/people/bajko/sounds/385280/",
      "licence": "CC0-1.0",
      "worlds": [
        "forest"
      ],
      "sourceUrl": "https://cdn.freesound.org/previews/385/385280_2341984-hq.ogg",
      "derivedFrom": "385280_2341984-hq.ogg",
      "sha256": "3aa09c776bfc2106c9dd1c9e62873a45a977cc85a9c4b3ea89163c5177ecd5b1",
      "stored": "3aa09c776bfc2106c9dd1c9e62873a45a977cc85a9c4b3ea89163c5177ecd5b1.ogg",
      "bytes": 252621,
      "served": true,
      "seconds": 45,
      "channels": 1,
      "sampleRate": 48000,
      "from": 38.5,
      "gainDb": 20.32,
      "lufs": -25.01,
      "truePeak": -2.21,
      "loop": true
    },
    {
      "id": "forest_leaves_02_arm_1k.jpg",
      "provider": "polyhaven",
      "asset": "forest_leaves_02",
      "kind": "texture",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Textures/jpg/1k/forest_leaves_02/forest_leaves_02_arm_1k.jpg",
      "md5": "876b7f364943f65c104c7b3127097596",
      "sourceSha256": "af70dcaa5f6c8770504132b5a3c25e9b9b5b431148c8796226492c8fff2bd6eb",
      "stored": "af70dcaa5f6c8770504132b5a3c25e9b9b5b431148c8796226492c8fff2bd6eb.jpg",
      "bytes": 313980,
      "served": true,
      "licence": "CC0-1.0",
      "worlds": [
        "forest"
      ],
      "width": 1024,
      "height": 1024,
      "averageColour": "#9aee03"
    },
    {
      "id": "forest_leaves_02_diffuse_1k.jpg",
      "provider": "polyhaven",
      "asset": "forest_leaves_02",
      "kind": "texture",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Textures/jpg/1k/forest_leaves_02/forest_leaves_02_diffuse_1k.jpg",
      "md5": "13e9bfac07cb72ca143e153cc2f589a8",
      "sourceSha256": "2bac85cdc76927fa7dc311037bbbc4dfa2633ea56eb0a24c9cabe163a68c9aa5",
      "stored": "2bac85cdc76927fa7dc311037bbbc4dfa2633ea56eb0a24c9cabe163a68c9aa5.jpg",
      "bytes": 437891,
      "served": true,
      "licence": "CC0-1.0",
      "worlds": [
        "forest"
      ],
      "width": 1024,
      "height": 1024,
      "averageColour": "#8e703a"
    },
    {
      "id": "forest_leaves_02_nor_gl_1k.jpg",
      "provider": "polyhaven",
      "asset": "forest_leaves_02",
      "kind": "texture",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Textures/jpg/1k/forest_leaves_02/forest_leaves_02_nor_gl_1k.jpg",
      "md5": "72002432222467c74cd9980cbddb25a4",
      "sourceSha256": "cf6a40ab24f44d3e891a92a1c252416ed1192af54ac92a5704bdfbda0805e290",
      "stored": "cf6a40ab24f44d3e891a92a1c252416ed1192af54ac92a5704bdfbda0805e290.jpg",
      "bytes": 577163,
      "served": true,
      "licence": "CC0-1.0",
      "worlds": [
        "forest"
      ],
      "width": 1024,
      "height": 1024,
      "averageColour": "#8181db"
    },
    {
      "id": "gravel_ground_01_arm_1k.jpg",
      "provider": "polyhaven",
      "asset": "gravel_ground_01",
      "kind": "texture",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Textures/jpg/1k/gravel_ground_01/gravel_ground_01_arm_1k.jpg",
      "md5": "1d4ee24a4dc226c24a2e8b5701c31797",
      "sourceSha256": "cf78bb8dd9c0079874ebceba2cbb58fc3eccf03d84204b3fccdcf0549b808e03",
      "stored": "cf78bb8dd9c0079874ebceba2cbb58fc3eccf03d84204b3fccdcf0549b808e03.jpg",
      "bytes": 151288,
      "served": true,
      "licence": "CC0-1.0",
      "worlds": [
        "volcanic-island"
      ],
      "width": 1024,
      "height": 1024,
      "averageColour": "#d6de01"
    },
    {
      "id": "gravel_ground_01_diff_1k.jpg",
      "provider": "polyhaven",
      "asset": "gravel_ground_01",
      "kind": "texture",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Textures/jpg/1k/gravel_ground_01/gravel_ground_01_diff_1k.jpg",
      "md5": "ee99ef89fb50cfeb198db369bb7151f0",
      "sourceSha256": "c3a12b0e3a9399913158dd5cfa1d67ede066970acd1f99e5b89969ac13f89089",
      "stored": "c3a12b0e3a9399913158dd5cfa1d67ede066970acd1f99e5b89969ac13f89089.jpg",
      "bytes": 954257,
      "served": true,
      "licence": "CC0-1.0",
      "worlds": [
        "polder",
        "volcanic-island"
      ],
      "width": 1024,
      "height": 1024,
      "averageColour": "#928368"
    },
    {
      "id": "gravel_ground_01_nor_gl_1k.jpg",
      "provider": "polyhaven",
      "asset": "gravel_ground_01",
      "kind": "texture",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Textures/jpg/1k/gravel_ground_01/gravel_ground_01_nor_gl_1k.jpg",
      "md5": "8a54072ce38665da29081d57dc10cb69",
      "sourceSha256": "3a832b27276d1457031b164147434558bd245469dc27fd1ff6ae075bde0b12b2",
      "stored": "3a832b27276d1457031b164147434558bd245469dc27fd1ff6ae075bde0b12b2.jpg",
      "bytes": 1314248,
      "served": true,
      "licence": "CC0-1.0",
      "worlds": [
        "volcanic-island"
      ],
      "width": 1024,
      "height": 1024,
      "averageColour": "#b8b7f4"
    },
    {
      "id": "gulls-loop.ogg",
      "provider": "freesound",
      "asset": "gulls",
      "kind": "audio",
      "sound": "Herring Gull 1",
      "user": "Canardo55",
      "page": "https://freesound.org/people/Canardo55/sounds/538016/",
      "licence": "CC0-1.0",
      "worlds": [
        "beach",
        "villa",
        "volcanic-island"
      ],
      "sourceUrl": "https://cdn.freesound.org/previews/538/538016_11982267-hq.ogg",
      "derivedFrom": "538016_11982267-hq.ogg",
      "sha256": "10c726eb682748b35d9dfe73aaf8a4be66446e76ef8bd63503a2b535a4d2d5c3",
      "stored": "10c726eb682748b35d9dfe73aaf8a4be66446e76ef8bd63503a2b535a4d2d5c3.ogg",
      "bytes": 101213,
      "served": true,
      "seconds": 30,
      "channels": 1,
      "sampleRate": 48000,
      "from": 0,
      "gainDb": -9.7,
      "lufs": -24,
      "truePeak": -12.01,
      "loop": true
    },
    {
      "id": "hospital_room_2_1k.hdr",
      "provider": "polyhaven",
      "asset": "hospital_room_2",
      "kind": "hdri",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/HDRIs/hdr/1k/hospital_room_2_1k.hdr",
      "md5": "b1b4c42bb1ef835676d28d3a18157dfa",
      "sourceSha256": "59034189601de322b5788c720ad09ebcb4fa4bae94f1a6e9e8a3839a966eeff3",
      "stored": "59034189601de322b5788c720ad09ebcb4fa4bae94f1a6e9e8a3839a966eeff3.hdr",
      "bytes": 1609763,
      "served": true,
      "licence": "CC0-1.0",
      "worlds": [
        "museum-hall",
        "science-lab"
      ],
      "width": 1024,
      "height": 512,
      "sun": {
        "direction": [
          0.3929,
          0.8918,
          0.2242
        ],
        "azimuth": 29.7,
        "elevation": 63.1,
        "linear": [
          46.25,
          51.778,
          53.611
        ]
      },
      "horizon": "#8994a8",
      "horizonLinear": [
        0.2001,
        0.238,
        0.3248
      ],
      "zenith": "#54595f",
      "zenithLinear": [
        0.0947,
        0.1041,
        0.1149
      ]
    },
    {
      "id": "industrial_microscope.bin",
      "provider": "polyhaven",
      "asset": "industrial_microscope",
      "kind": "bin",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/gltf/4k/industrial_microscope/industrial_microscope.bin",
      "md5": "be2a9782f02eabcc9a02f67dd7c6fd33",
      "sourceSha256": "a99e95a04673b96f7d6eb8cd68e204a76abde77c7dad3bcaea79e55219aeea40",
      "stored": "a99e95a04673b96f7d6eb8cd68e204a76abde77c7dad3bcaea79e55219aeea40.bin",
      "bytes": 602404,
      "served": true,
      "licence": "CC0-1.0",
      "worlds": [
        "museum-hall",
        "science-lab"
      ]
    },
    {
      "id": "industrial_microscope.gltf",
      "provider": "polyhaven",
      "asset": "industrial_microscope",
      "kind": "gltf",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/gltf/1k/industrial_microscope/industrial_microscope_1k.gltf",
      "derivedFrom": "industrial_microscope_1k.gltf",
      "sha256": "40af8cd728b531f4af23dc32bd7944aa9bddceabf4021bad7596ff968f89dbf6",
      "stored": "40af8cd728b531f4af23dc32bd7944aa9bddceabf4021bad7596ff968f89dbf6.gltf",
      "bytes": 2713,
      "served": true,
      "licence": "CC0-1.0",
      "worlds": [
        "museum-hall",
        "science-lab"
      ],
      "triangles": 16598,
      "primitives": 2,
      "materials": 1,
      "bounds": {
        "min": [
          -0.0938,
          -0.0016,
          -0.3315
        ],
        "max": [
          0.1208,
          0.4601,
          0.1666
        ]
      },
      "requires": [
        "a99e95a04673b96f7d6eb8cd68e204a76abde77c7dad3bcaea79e55219aeea40.bin",
        "a9ad1ed0427d4f742c850f27a2ce267f515c07b75de84a8c869f0a07858397a1.jpg",
        "ec706da8b0b677375e04caadb75910a488d13900f1325a0f8afa547d0ef8bf43.jpg",
        "f43c4d6a74032348a32948af39d83715ce2d7c26939f4be5804507f1f39d58f9.jpg"
      ],
      "resizedTo": 512
    },
    {
      "id": "industrial_microscope_1k.gltf",
      "provider": "polyhaven",
      "asset": "industrial_microscope",
      "kind": "gltf",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/gltf/1k/industrial_microscope/industrial_microscope_1k.gltf",
      "md5": "472c893cc84e3f7e9f76454aba612e42",
      "sourceSha256": "91151cd484cf8f991c822f53a48487b8fa0a228cd7ccf63fbba625e1d70abb2a",
      "stored": "91151cd484cf8f991c822f53a48487b8fa0a228cd7ccf63fbba625e1d70abb2a.gltf",
      "bytes": 4270,
      "served": false,
      "licence": "CC0-1.0",
      "worlds": [
        "science-lab"
      ],
      "triangles": 16598,
      "primitives": 2,
      "materials": 1,
      "bounds": {
        "min": [
          -0.0938,
          -0.0016,
          -0.3315
        ],
        "max": [
          0.1208,
          0.4601,
          0.1666
        ]
      }
    },
    {
      "id": "industrial_microscope_arm_1k.jpg",
      "provider": "polyhaven",
      "asset": "industrial_microscope",
      "kind": "texture",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/jpg/1k/industrial_microscope/industrial_microscope_arm_1k.jpg",
      "md5": "16d17224f4750da5f0c99c6ac8e1771b",
      "sourceSha256": "01f0df732a82c90f552be5ba08ab7a58fdb62d63b2989fa7333f23e75322949e",
      "stored": "01f0df732a82c90f552be5ba08ab7a58fdb62d63b2989fa7333f23e75322949e.jpg",
      "bytes": 775071,
      "served": false,
      "licence": "CC0-1.0",
      "worlds": [
        "science-lab"
      ],
      "width": 1024,
      "height": 1024,
      "averageColour": "#b25d4a"
    },
    {
      "id": "industrial_microscope_arm_512.jpg",
      "provider": "polyhaven",
      "asset": "industrial_microscope",
      "kind": "texture",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/jpg/1k/industrial_microscope/industrial_microscope_arm_1k.jpg",
      "derivedFrom": "industrial_microscope_arm_1k.jpg",
      "sha256": "ec706da8b0b677375e04caadb75910a488d13900f1325a0f8afa547d0ef8bf43",
      "stored": "ec706da8b0b677375e04caadb75910a488d13900f1325a0f8afa547d0ef8bf43.jpg",
      "bytes": 72410,
      "served": true,
      "licence": "CC0-1.0",
      "worlds": [
        "museum-hall",
        "science-lab"
      ],
      "width": 512,
      "height": 512,
      "averageColour": "#b25d4a"
    },
    {
      "id": "industrial_microscope_diff_1k.jpg",
      "provider": "polyhaven",
      "asset": "industrial_microscope",
      "kind": "texture",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/jpg/1k/industrial_microscope/industrial_microscope_diff_1k.jpg",
      "md5": "d98e729ea074d94a3a3e34050bc68a94",
      "sourceSha256": "a870e4533ae2f24c217c0744097436e7914946ffbda88ee054d0ee5c03054973",
      "stored": "a870e4533ae2f24c217c0744097436e7914946ffbda88ee054d0ee5c03054973.jpg",
      "bytes": 508322,
      "served": false,
      "licence": "CC0-1.0",
      "worlds": [
        "science-lab"
      ],
      "width": 1024,
      "height": 1024,
      "averageColour": "#575b59"
    },
    {
      "id": "industrial_microscope_diff_512.jpg",
      "provider": "polyhaven",
      "asset": "industrial_microscope",
      "kind": "texture",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/jpg/1k/industrial_microscope/industrial_microscope_diff_1k.jpg",
      "derivedFrom": "industrial_microscope_diff_1k.jpg",
      "sha256": "a9ad1ed0427d4f742c850f27a2ce267f515c07b75de84a8c869f0a07858397a1",
      "stored": "a9ad1ed0427d4f742c850f27a2ce267f515c07b75de84a8c869f0a07858397a1.jpg",
      "bytes": 51349,
      "served": true,
      "licence": "CC0-1.0",
      "worlds": [
        "museum-hall",
        "science-lab"
      ],
      "width": 512,
      "height": 512,
      "averageColour": "#575b59"
    },
    {
      "id": "industrial_microscope_nor_gl_1k.jpg",
      "provider": "polyhaven",
      "asset": "industrial_microscope",
      "kind": "texture",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/jpg/1k/industrial_microscope/industrial_microscope_nor_gl_1k.jpg",
      "md5": "2e3d69f1bf720fa98bd3c76708a0b471",
      "sourceSha256": "ae31cce984a953bef60919c56bbc0b159cafeab96145f264937b6188e5b987ec",
      "stored": "ae31cce984a953bef60919c56bbc0b159cafeab96145f264937b6188e5b987ec.jpg",
      "bytes": 566472,
      "served": false,
      "licence": "CC0-1.0",
      "worlds": [
        "science-lab"
      ],
      "width": 1024,
      "height": 1024,
      "averageColour": "#8280f7"
    },
    {
      "id": "industrial_microscope_nor_gl_512.jpg",
      "provider": "polyhaven",
      "asset": "industrial_microscope",
      "kind": "texture",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/jpg/1k/industrial_microscope/industrial_microscope_nor_gl_1k.jpg",
      "derivedFrom": "industrial_microscope_nor_gl_1k.jpg",
      "sha256": "f43c4d6a74032348a32948af39d83715ce2d7c26939f4be5804507f1f39d58f9",
      "stored": "f43c4d6a74032348a32948af39d83715ce2d7c26939f4be5804507f1f39d58f9.jpg",
      "bytes": 57198,
      "served": true,
      "licence": "CC0-1.0",
      "worlds": [
        "museum-hall",
        "science-lab"
      ],
      "width": 512,
      "height": 512,
      "averageColour": "#8280f6"
    },
    {
      "id": "kloofendal_48d_partly_cloudy_puresky_2k.hdr",
      "provider": "polyhaven",
      "asset": "kloofendal_48d_partly_cloudy_puresky",
      "kind": "hdri",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/HDRIs/hdr/2k/kloofendal_48d_partly_cloudy_puresky_2k.hdr",
      "md5": "2eba3a4d7eeb23cbfbeca364c97e7980",
      "sourceSha256": "5244534e9cf5b606f2ff513aa00ddb161b0a4826ffd88a0d3bd03ac29247d198",
      "stored": "5244534e9cf5b606f2ff513aa00ddb161b0a4826ffd88a0d3bd03ac29247d198.hdr",
      "bytes": 5451493,
      "served": true,
      "licence": "CC0-1.0",
      "worlds": [
        "beach",
        "forest",
        "meadow",
        "modern-street",
        "sea-floor",
        "town-square",
        "villa",
        "volcanic-island"
      ],
      "width": 2048,
      "height": 1024,
      "sun": {
        "direction": [
          0.5546,
          0.742,
          0.3767
        ],
        "azimuth": 34.2,
        "elevation": 47.9,
        "linear": [
          53660.444,
          54741.333,
          50432
        ]
      },
      "horizon": "#bdc1ca",
      "horizonLinear": [
        0.4316,
        0.464,
        0.5619
      ],
      "zenith": "#c5c9d4",
      "zenithLinear": [
        0.4954,
        0.5395,
        0.6918
      ]
    },
    {
      "id": "marble_01_arm_1k.jpg",
      "provider": "polyhaven",
      "asset": "marble_01",
      "kind": "texture",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Textures/jpg/1k/marble_01/marble_01_arm_1k.jpg",
      "md5": "51017a4e4f320c3b58763c66727d89c1",
      "sourceSha256": "84b1516c27b4393230e77e0aa525186b4a8a415169661a4385f02dcb10c14104",
      "stored": "84b1516c27b4393230e77e0aa525186b4a8a415169661a4385f02dcb10c14104.jpg",
      "bytes": 54740,
      "served": true,
      "licence": "CC0-1.0",
      "worlds": [
        "museum-hall"
      ],
      "width": 1024,
      "height": 1024,
      "averageColour": "#f58100"
    },
    {
      "id": "marble_01_diff_1k.jpg",
      "provider": "polyhaven",
      "asset": "marble_01",
      "kind": "texture",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Textures/jpg/1k/marble_01/marble_01_diff_1k.jpg",
      "md5": "04325ced5018eb8a2e598a4ef69cb176",
      "sourceSha256": "b10dabea976d68baa976a0d4e8dac58789df8d26a1b50697f320106f1b00a229",
      "stored": "b10dabea976d68baa976a0d4e8dac58789df8d26a1b50697f320106f1b00a229.jpg",
      "bytes": 305029,
      "served": true,
      "licence": "CC0-1.0",
      "worlds": [
        "museum-hall"
      ],
      "width": 1024,
      "height": 1024,
      "averageColour": "#b19d7a"
    },
    {
      "id": "marble_01_nor_gl_1k.jpg",
      "provider": "polyhaven",
      "asset": "marble_01",
      "kind": "texture",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Textures/jpg/1k/marble_01/marble_01_nor_gl_1k.jpg",
      "md5": "fa073d722cde733c1bd6cc6e8897c8e3",
      "sourceSha256": "77c2a9b549a6a408659f8197be91945aeb0abc33e697f1dd2ce24ee8dc7c2bc0",
      "stored": "77c2a9b549a6a408659f8197be91945aeb0abc33e697f1dd2ce24ee8dc7c2bc0.jpg",
      "bytes": 110230,
      "served": true,
      "licence": "CC0-1.0",
      "worlds": [
        "museum-hall"
      ],
      "width": 1024,
      "height": 1024,
      "averageColour": "#7d7cfd"
    },
    {
      "id": "marble_bust_01.bin",
      "provider": "polyhaven",
      "asset": "marble_bust_01",
      "kind": "bin",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/gltf/8k/marble_bust_01/marble_bust_01.bin",
      "md5": "1c62c1189a0e8985618c1662e1bd25a3",
      "sourceSha256": "0bb757c1bd00bfe42005c84e7f76df98ce04a532e595a2ddda8a0335cd959e33",
      "stored": "0bb757c1bd00bfe42005c84e7f76df98ce04a532e595a2ddda8a0335cd959e33.bin",
      "bytes": 416608,
      "served": false,
      "licence": "CC0-1.0",
      "worlds": []
    },
    {
      "id": "marble_bust_01.gltf",
      "provider": "polyhaven",
      "asset": "marble_bust_01",
      "kind": "gltf",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/gltf/1k/marble_bust_01/marble_bust_01_1k.gltf",
      "derivedFrom": "marble_bust_01_1k.gltf",
      "sha256": "3eddd4be5ecc857f7a3a30f4cabefb359c48633c0f0344df3720b8e41d795227",
      "stored": "3eddd4be5ecc857f7a3a30f4cabefb359c48633c0f0344df3720b8e41d795227.gltf",
      "bytes": 1863,
      "served": true,
      "licence": "CC0-1.0",
      "worlds": [
        "museum-hall"
      ],
      "triangles": 5000,
      "primitives": 1,
      "materials": 1,
      "bounds": {
        "min": [
          -0.1229,
          0.0002,
          -0.1446
        ],
        "max": [
          0.1489,
          0.515,
          0.1551
        ]
      },
      "requires": [
        "3f271b966d9e2b055c7b3328195896c2b9ee5a8715ca0c247825bdf625576dba.jpg",
        "7b8fd4851fc127ef3161e0c28bf685f17b3c1153aca5805dc292487867423d07.jpg",
        "df734fa6e866fea0a32a3b4da3b1dfcdfc6aba7d154eee35678617aa3eedc493.jpg",
        "f020d56f459b1b251acefdc9f6431d8aa39d2f4069a63a708d4a12ebcb4d3c79.bin"
      ],
      "simplifiedFrom": 17456,
      "variants": [
        {
          "name": "marble_bust_01",
          "triangles": 5000,
          "size": [
            0.272,
            0.515,
            0.3
          ]
        }
      ],
      "resizedTo": 512
    },
    {
      "id": "marble_bust_01_1k.gltf",
      "provider": "polyhaven",
      "asset": "marble_bust_01",
      "kind": "gltf",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/gltf/1k/marble_bust_01/marble_bust_01_1k.gltf",
      "md5": "599d6dd71c2dcdffa064b1c1d85882f4",
      "sourceSha256": "b6f192fc01be4349470b66f6f6948bd37620267bdbc86f4568e4d078f97ff09b",
      "stored": "b6f192fc01be4349470b66f6f6948bd37620267bdbc86f4568e4d078f97ff09b.gltf",
      "bytes": 2793,
      "served": false,
      "licence": "CC0-1.0",
      "worlds": [],
      "triangles": 17456,
      "primitives": 1,
      "materials": 1,
      "bounds": {
        "min": [
          -0.1229,
          0.0001,
          -0.1446
        ],
        "max": [
          0.1489,
          0.515,
          0.1551
        ]
      }
    },
    {
      "id": "marble_bust_01_diff_1k.jpg",
      "provider": "polyhaven",
      "asset": "marble_bust_01",
      "kind": "texture",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/jpg/1k/marble_bust_01/marble_bust_01_diff_1k.jpg",
      "md5": "aede40cc2b092d91a5f72598c911da4f",
      "sourceSha256": "cbb7dccdc62d7eaa240eef7b4956969bf6e73c7338b64f1378629838ea22383c",
      "stored": "cbb7dccdc62d7eaa240eef7b4956969bf6e73c7338b64f1378629838ea22383c.jpg",
      "bytes": 160337,
      "served": false,
      "licence": "CC0-1.0",
      "worlds": [],
      "width": 1024,
      "height": 1024,
      "averageColour": "#a0988a"
    },
    {
      "id": "marble_bust_01_diff_512.jpg",
      "provider": "polyhaven",
      "asset": "marble_bust_01",
      "kind": "texture",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/jpg/1k/marble_bust_01/marble_bust_01_diff_1k.jpg",
      "derivedFrom": "marble_bust_01_diff_1k.jpg",
      "sha256": "3f271b966d9e2b055c7b3328195896c2b9ee5a8715ca0c247825bdf625576dba",
      "stored": "3f271b966d9e2b055c7b3328195896c2b9ee5a8715ca0c247825bdf625576dba.jpg",
      "bytes": 44803,
      "served": true,
      "licence": "CC0-1.0",
      "worlds": [
        "museum-hall"
      ],
      "width": 512,
      "height": 512,
      "averageColour": "#a0988a"
    },
    {
      "id": "marble_bust_01_nor_gl_1k.jpg",
      "provider": "polyhaven",
      "asset": "marble_bust_01",
      "kind": "texture",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/jpg/1k/marble_bust_01/marble_bust_01_nor_gl_1k.jpg",
      "md5": "134149a7e8f142fcb605f0bde52b3ff6",
      "sourceSha256": "3d355904cd54c2de90d5d4310b80d43816fa2dd509f0a3445d654eab8e237c5f",
      "stored": "3d355904cd54c2de90d5d4310b80d43816fa2dd509f0a3445d654eab8e237c5f.jpg",
      "bytes": 124627,
      "served": false,
      "licence": "CC0-1.0",
      "worlds": [],
      "width": 1024,
      "height": 1024,
      "averageColour": "#8080fd"
    },
    {
      "id": "marble_bust_01_nor_gl_512.jpg",
      "provider": "polyhaven",
      "asset": "marble_bust_01",
      "kind": "texture",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/jpg/1k/marble_bust_01/marble_bust_01_nor_gl_1k.jpg",
      "derivedFrom": "marble_bust_01_nor_gl_1k.jpg",
      "sha256": "7b8fd4851fc127ef3161e0c28bf685f17b3c1153aca5805dc292487867423d07",
      "stored": "7b8fd4851fc127ef3161e0c28bf685f17b3c1153aca5805dc292487867423d07.jpg",
      "bytes": 39472,
      "served": true,
      "licence": "CC0-1.0",
      "worlds": [
        "museum-hall"
      ],
      "width": 512,
      "height": 512,
      "averageColour": "#8080fc"
    },
    {
      "id": "marble_bust_01_rough_1k.jpg",
      "provider": "polyhaven",
      "asset": "marble_bust_01",
      "kind": "texture",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/jpg/1k/marble_bust_01/marble_bust_01_rough_1k.jpg",
      "md5": "9fdff7b2b17d12fcc478de3021f561dd",
      "sourceSha256": "1c4502352dc936dd1f1c1a81b418706df1ce0445949874215015325f9b8921fb",
      "stored": "1c4502352dc936dd1f1c1a81b418706df1ce0445949874215015325f9b8921fb.jpg",
      "bytes": 193918,
      "served": false,
      "licence": "CC0-1.0",
      "worlds": [],
      "width": 1024,
      "height": 1024,
      "averageColour": "#52"
    },
    {
      "id": "marble_bust_01_rough_512.jpg",
      "provider": "polyhaven",
      "asset": "marble_bust_01",
      "kind": "texture",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/jpg/1k/marble_bust_01/marble_bust_01_rough_1k.jpg",
      "derivedFrom": "marble_bust_01_rough_1k.jpg",
      "sha256": "df734fa6e866fea0a32a3b4da3b1dfcdfc6aba7d154eee35678617aa3eedc493",
      "stored": "df734fa6e866fea0a32a3b4da3b1dfcdfc6aba7d154eee35678617aa3eedc493.jpg",
      "bytes": 52718,
      "served": true,
      "licence": "CC0-1.0",
      "worlds": [
        "museum-hall"
      ],
      "width": 512,
      "height": 512,
      "averageColour": "#525252"
    },
    {
      "id": "marble_bust_01_simplified.bin",
      "provider": "polyhaven",
      "asset": "marble_bust_01",
      "kind": "bin",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/gltf/8k/marble_bust_01/marble_bust_01.bin",
      "derivedFrom": "marble_bust_01.bin",
      "sha256": "f020d56f459b1b251acefdc9f6431d8aa39d2f4069a63a708d4a12ebcb4d3c79",
      "stored": "f020d56f459b1b251acefdc9f6431d8aa39d2f4069a63a708d4a12ebcb4d3c79.bin",
      "bytes": 128176,
      "served": true,
      "licence": "CC0-1.0",
      "worlds": [
        "museum-hall"
      ]
    },
    {
      "id": "market-loop.ogg",
      "provider": "freesound",
      "asset": "market",
      "kind": "audio",
      "sound": "Wegetable market Poznan R.Jezycki",
      "user": "PITFACTORY",
      "page": "https://freesound.org/people/PITFACTORY/sounds/363003/",
      "licence": "CC0-1.0",
      "worlds": [
        "town-square"
      ],
      "sourceUrl": "https://cdn.freesound.org/previews/363/363003_4000697-hq.ogg",
      "derivedFrom": "363003_4000697-hq.ogg",
      "sha256": "9dca5509de0098f84fcf1f737285a6708c5ab81fedff1c34bf882447d9c090f8",
      "stored": "9dca5509de0098f84fcf1f737285a6708c5ab81fedff1c34bf882447d9c090f8.ogg",
      "bytes": 248775,
      "served": true,
      "seconds": 45,
      "channels": 1,
      "sampleRate": 48000,
      "from": 14,
      "gainDb": -1.92,
      "lufs": -30.28,
      "truePeak": -2.69,
      "loop": true
    },
    {
      "id": "metal_stool_02.bin",
      "provider": "polyhaven",
      "asset": "metal_stool_02",
      "kind": "bin",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/gltf/8k/metal_stool_02/metal_stool_02.bin",
      "md5": "e2e2cc4b51e8311ac936430e5f51afc2",
      "sourceSha256": "17127317d391eb90ce3446739463b1067cc490210db821769b7a46bd1ff02e1c",
      "stored": "17127317d391eb90ce3446739463b1067cc490210db821769b7a46bd1ff02e1c.bin",
      "bytes": 182872,
      "served": true,
      "licence": "CC0-1.0",
      "worlds": [
        "museum-hall",
        "science-lab"
      ]
    },
    {
      "id": "metal_stool_02.gltf",
      "provider": "polyhaven",
      "asset": "metal_stool_02",
      "kind": "gltf",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/gltf/1k/metal_stool_02/metal_stool_02_1k.gltf",
      "derivedFrom": "metal_stool_02_1k.gltf",
      "sha256": "280bd202e044da69fac902b280bf15d1e504a7e63ae87fcf25ea1cc9668a5894",
      "stored": "280bd202e044da69fac902b280bf15d1e504a7e63ae87fcf25ea1cc9668a5894.gltf",
      "bytes": 1912,
      "served": true,
      "licence": "CC0-1.0",
      "worlds": [
        "museum-hall",
        "science-lab"
      ],
      "triangles": 6532,
      "primitives": 1,
      "materials": 1,
      "bounds": {
        "min": [
          -0.224,
          0,
          -0.2352
        ],
        "max": [
          0.2241,
          0.4581,
          0.2379
        ]
      },
      "requires": [
        "114d048c956924af7b568a0736ea9346e8e33e8183406236ddd1d1dc4967e70c.jpg",
        "17127317d391eb90ce3446739463b1067cc490210db821769b7a46bd1ff02e1c.bin",
        "923cf703210ea57a6eae25d2135fdf3df9f72b9e09fb273b28b898adf34dd82a.jpg",
        "f0d80a117a0fbbf56e1eeeaed272d9ba69d274ef7135d3b9992dada13975862d.jpg"
      ],
      "resizedTo": 512
    },
    {
      "id": "metal_stool_02_1k.gltf",
      "provider": "polyhaven",
      "asset": "metal_stool_02",
      "kind": "gltf",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/gltf/1k/metal_stool_02/metal_stool_02_1k.gltf",
      "md5": "52bc62d1b46276ef64133151d2388385",
      "sourceSha256": "de8d603993443294b8a0aed48ea631ac38f2b15872491ea929551f72be726fcb",
      "stored": "de8d603993443294b8a0aed48ea631ac38f2b15872491ea929551f72be726fcb.gltf",
      "bytes": 2897,
      "served": false,
      "licence": "CC0-1.0",
      "worlds": [
        "science-lab"
      ],
      "triangles": 6532,
      "primitives": 1,
      "materials": 1,
      "bounds": {
        "min": [
          -0.224,
          0,
          -0.2352
        ],
        "max": [
          0.2241,
          0.4581,
          0.2379
        ]
      }
    },
    {
      "id": "metal_stool_02_arm_1k.jpg",
      "provider": "polyhaven",
      "asset": "metal_stool_02",
      "kind": "texture",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/jpg/1k/metal_stool_02/metal_stool_02_arm_1k.jpg",
      "md5": "dc4ddb00b46b843a8236f7488d5117e0",
      "sourceSha256": "dff17b725379af449dae2af9f5224d8b3e863d2dbd645f13d5f4c8b2c9aa1999",
      "stored": "dff17b725379af449dae2af9f5224d8b3e863d2dbd645f13d5f4c8b2c9aa1999.jpg",
      "bytes": 854331,
      "served": false,
      "licence": "CC0-1.0",
      "worlds": [
        "science-lab"
      ],
      "width": 1024,
      "height": 1024,
      "averageColour": "#b6ab0b"
    },
    {
      "id": "metal_stool_02_arm_512.jpg",
      "provider": "polyhaven",
      "asset": "metal_stool_02",
      "kind": "texture",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/jpg/1k/metal_stool_02/metal_stool_02_arm_1k.jpg",
      "derivedFrom": "metal_stool_02_arm_1k.jpg",
      "sha256": "114d048c956924af7b568a0736ea9346e8e33e8183406236ddd1d1dc4967e70c",
      "stored": "114d048c956924af7b568a0736ea9346e8e33e8183406236ddd1d1dc4967e70c.jpg",
      "bytes": 65892,
      "served": true,
      "licence": "CC0-1.0",
      "worlds": [
        "museum-hall",
        "science-lab"
      ],
      "width": 512,
      "height": 512,
      "averageColour": "#b6ab0d"
    },
    {
      "id": "metal_stool_02_diff_1k.jpg",
      "provider": "polyhaven",
      "asset": "metal_stool_02",
      "kind": "texture",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/jpg/1k/metal_stool_02/metal_stool_02_diff_1k.jpg",
      "md5": "b470e8320de149ba7e6561c173efbeae",
      "sourceSha256": "6dd23ca9932da71c37eb537e7d996e1cc7fc8752c566cec0f7e18690c06f07af",
      "stored": "6dd23ca9932da71c37eb537e7d996e1cc7fc8752c566cec0f7e18690c06f07af.jpg",
      "bytes": 776056,
      "served": false,
      "licence": "CC0-1.0",
      "worlds": [
        "science-lab"
      ],
      "width": 1024,
      "height": 1024,
      "averageColour": "#494135"
    },
    {
      "id": "metal_stool_02_diff_512.jpg",
      "provider": "polyhaven",
      "asset": "metal_stool_02",
      "kind": "texture",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/jpg/1k/metal_stool_02/metal_stool_02_diff_1k.jpg",
      "derivedFrom": "metal_stool_02_diff_1k.jpg",
      "sha256": "923cf703210ea57a6eae25d2135fdf3df9f72b9e09fb273b28b898adf34dd82a",
      "stored": "923cf703210ea57a6eae25d2135fdf3df9f72b9e09fb273b28b898adf34dd82a.jpg",
      "bytes": 53805,
      "served": true,
      "licence": "CC0-1.0",
      "worlds": [
        "museum-hall",
        "science-lab"
      ],
      "width": 512,
      "height": 512,
      "averageColour": "#494135"
    },
    {
      "id": "metal_stool_02_nor_gl_1k.jpg",
      "provider": "polyhaven",
      "asset": "metal_stool_02",
      "kind": "texture",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/jpg/1k/metal_stool_02/metal_stool_02_nor_gl_1k.jpg",
      "md5": "7871114c94f3b795bc08346e3a57c9f6",
      "sourceSha256": "65d0a8be725f094222ca5badf388042d76f24e374398fc0cfb579bc03a29a8c6",
      "stored": "65d0a8be725f094222ca5badf388042d76f24e374398fc0cfb579bc03a29a8c6.jpg",
      "bytes": 724830,
      "served": false,
      "licence": "CC0-1.0",
      "worlds": [
        "science-lab"
      ],
      "width": 1024,
      "height": 1024,
      "averageColour": "#7f80f8"
    },
    {
      "id": "metal_stool_02_nor_gl_512.jpg",
      "provider": "polyhaven",
      "asset": "metal_stool_02",
      "kind": "texture",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/jpg/1k/metal_stool_02/metal_stool_02_nor_gl_1k.jpg",
      "derivedFrom": "metal_stool_02_nor_gl_1k.jpg",
      "sha256": "f0d80a117a0fbbf56e1eeeaed272d9ba69d274ef7135d3b9992dada13975862d",
      "stored": "f0d80a117a0fbbf56e1eeeaed272d9ba69d274ef7135d3b9992dada13975862d.jpg",
      "bytes": 31550,
      "served": true,
      "licence": "CC0-1.0",
      "worlds": [
        "museum-hall",
        "science-lab"
      ],
      "width": 512,
      "height": 512,
      "averageColour": "#7f80f8"
    },
    {
      "id": "moon_rock_02.bin",
      "provider": "polyhaven",
      "asset": "moon_rock_02",
      "kind": "bin",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/gltf/8k/moon_rock_02/moon_rock_02.bin",
      "md5": "42490de969f582a69518a40e17fe3f53",
      "sourceSha256": "3ba6af10eebb46347e4e0c9d3e2a836d1328525d9d47e82b798a13d9ca2b216f",
      "stored": "3ba6af10eebb46347e4e0c9d3e2a836d1328525d9d47e82b798a13d9ca2b216f.bin",
      "bytes": 78928,
      "served": true,
      "licence": "CC0-1.0",
      "worlds": [
        "forest",
        "sea-floor",
        "volcanic-island"
      ]
    },
    {
      "id": "moon_rock_02.gltf",
      "provider": "polyhaven",
      "asset": "moon_rock_02",
      "kind": "gltf",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/gltf/1k/moon_rock_02/moon_rock_02_1k.gltf",
      "derivedFrom": "moon_rock_02_1k.gltf",
      "sha256": "56bce4244b46099f0a656dc01af9c5a7e477f77381b52488b8e74853365cd5d3",
      "stored": "56bce4244b46099f0a656dc01af9c5a7e477f77381b52488b8e74853365cd5d3.gltf",
      "bytes": 1846,
      "served": true,
      "licence": "CC0-1.0",
      "worlds": [
        "forest",
        "sea-floor",
        "volcanic-island"
      ],
      "triangles": 3304,
      "primitives": 1,
      "materials": 1,
      "bounds": {
        "min": [
          -0.1247,
          -0.0061,
          -0.1251
        ],
        "max": [
          0.1218,
          0.1959,
          0.1262
        ]
      },
      "requires": [
        "2461d38704c282b5de6e25a3cde991989f5f719f4a19245f85c466420f57a15c.jpg",
        "3ba6af10eebb46347e4e0c9d3e2a836d1328525d9d47e82b798a13d9ca2b216f.bin",
        "8abd3dacb2638ce546603349585f9561e0d5735738b3a6b74dffc1a89410c4bb.jpg",
        "e0bab560697e8bf3eca3091b48817fb5dfa1a86f09019f29092eadde47c0c952.jpg"
      ],
      "resizedTo": 512
    },
    {
      "id": "moon_rock_02_1k.gltf",
      "provider": "polyhaven",
      "asset": "moon_rock_02",
      "kind": "gltf",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/gltf/1k/moon_rock_02/moon_rock_02_1k.gltf",
      "md5": "2237fe252e6a0f4ae26617f749a5c7b6",
      "sourceSha256": "fada2419ab6de440c24081bf06545f37c41c3d4f8bb57fc4d1ba45bdb35baf5d",
      "stored": "fada2419ab6de440c24081bf06545f37c41c3d4f8bb57fc4d1ba45bdb35baf5d.gltf",
      "bytes": 2782,
      "served": false,
      "licence": "CC0-1.0",
      "worlds": [
        "volcanic-island"
      ],
      "triangles": 3304,
      "primitives": 1,
      "materials": 1,
      "bounds": {
        "min": [
          -0.1247,
          -0.0061,
          -0.1251
        ],
        "max": [
          0.1218,
          0.1959,
          0.1262
        ]
      }
    },
    {
      "id": "moon_rock_02_arm_1k.jpg",
      "provider": "polyhaven",
      "asset": "moon_rock_02",
      "kind": "texture",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/jpg/1k/moon_rock_02/moon_rock_02_arm_1k.jpg",
      "md5": "a99f416adc4a059b2db7c3aa72e8fe92",
      "sourceSha256": "4b87eaca9c57ecb145b26033cfb9fbb03191b67777458e4e699eaca823cca0e2",
      "stored": "4b87eaca9c57ecb145b26033cfb9fbb03191b67777458e4e699eaca823cca0e2.jpg",
      "bytes": 366382,
      "served": false,
      "licence": "CC0-1.0",
      "worlds": [
        "volcanic-island"
      ],
      "width": 1024,
      "height": 1024,
      "averageColour": "#eff500"
    },
    {
      "id": "moon_rock_02_arm_512.jpg",
      "provider": "polyhaven",
      "asset": "moon_rock_02",
      "kind": "texture",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/jpg/1k/moon_rock_02/moon_rock_02_arm_1k.jpg",
      "derivedFrom": "moon_rock_02_arm_1k.jpg",
      "sha256": "e0bab560697e8bf3eca3091b48817fb5dfa1a86f09019f29092eadde47c0c952",
      "stored": "e0bab560697e8bf3eca3091b48817fb5dfa1a86f09019f29092eadde47c0c952.jpg",
      "bytes": 17357,
      "served": true,
      "licence": "CC0-1.0",
      "worlds": [
        "forest",
        "sea-floor",
        "volcanic-island"
      ],
      "width": 512,
      "height": 512,
      "averageColour": "#eff501"
    },
    {
      "id": "moon_rock_02_diff_1k.jpg",
      "provider": "polyhaven",
      "asset": "moon_rock_02",
      "kind": "texture",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/jpg/1k/moon_rock_02/moon_rock_02_diff_1k.jpg",
      "md5": "48a8ec745b864870d38bd69bcf498b8f",
      "sourceSha256": "2df7bedcd0f169d76f37af52768c2a674019b6c6b812492a47c230726cff96ad",
      "stored": "2df7bedcd0f169d76f37af52768c2a674019b6c6b812492a47c230726cff96ad.jpg",
      "bytes": 394361,
      "served": false,
      "licence": "CC0-1.0",
      "worlds": [
        "volcanic-island"
      ],
      "width": 1024,
      "height": 1024,
      "averageColour": "#868074"
    },
    {
      "id": "moon_rock_02_diff_512.jpg",
      "provider": "polyhaven",
      "asset": "moon_rock_02",
      "kind": "texture",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/jpg/1k/moon_rock_02/moon_rock_02_diff_1k.jpg",
      "derivedFrom": "moon_rock_02_diff_1k.jpg",
      "sha256": "2461d38704c282b5de6e25a3cde991989f5f719f4a19245f85c466420f57a15c",
      "stored": "2461d38704c282b5de6e25a3cde991989f5f719f4a19245f85c466420f57a15c.jpg",
      "bytes": 16838,
      "served": true,
      "licence": "CC0-1.0",
      "worlds": [
        "forest",
        "sea-floor",
        "volcanic-island"
      ],
      "width": 512,
      "height": 512,
      "averageColour": "#868074"
    },
    {
      "id": "moon_rock_02_nor_gl_1k.jpg",
      "provider": "polyhaven",
      "asset": "moon_rock_02",
      "kind": "texture",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/jpg/1k/moon_rock_02/moon_rock_02_nor_gl_1k.jpg",
      "md5": "3adf62ed6ca7cd2431f27649dbcb7ad6",
      "sourceSha256": "6c7a4c51e89ee1b66b243a8341e8491bcc5a9151c30feee5b35e19742106f872",
      "stored": "6c7a4c51e89ee1b66b243a8341e8491bcc5a9151c30feee5b35e19742106f872.jpg",
      "bytes": 675121,
      "served": false,
      "licence": "CC0-1.0",
      "worlds": [
        "volcanic-island"
      ],
      "width": 1024,
      "height": 1024,
      "averageColour": "#7f7ffd"
    },
    {
      "id": "moon_rock_02_nor_gl_512.jpg",
      "provider": "polyhaven",
      "asset": "moon_rock_02",
      "kind": "texture",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/jpg/1k/moon_rock_02/moon_rock_02_nor_gl_1k.jpg",
      "derivedFrom": "moon_rock_02_nor_gl_1k.jpg",
      "sha256": "8abd3dacb2638ce546603349585f9561e0d5735738b3a6b74dffc1a89410c4bb",
      "stored": "8abd3dacb2638ce546603349585f9561e0d5735738b3a6b74dffc1a89410c4bb.jpg",
      "bytes": 52513,
      "served": true,
      "licence": "CC0-1.0",
      "worlds": [
        "forest",
        "sea-floor",
        "volcanic-island"
      ],
      "width": 512,
      "height": 512,
      "averageColour": "#7f7ffc"
    },
    {
      "id": "museum-hall-loop.ogg",
      "provider": "freesound",
      "asset": "museum-hall",
      "kind": "audio",
      "sound": "London Museum Inside 1",
      "user": "Alcappuccino",
      "page": "https://freesound.org/people/Alcappuccino/sounds/263573/",
      "licence": "CC0-1.0",
      "worlds": [
        "museum-hall"
      ],
      "sourceUrl": "https://cdn.freesound.org/previews/263/263573_4536481-hq.ogg",
      "derivedFrom": "263573_4536481-hq.ogg",
      "sha256": "1607f12910ad342a69413f72e56f63a5bffca30140cadb8d2c1591f94aecd2bb",
      "stored": "1607f12910ad342a69413f72e56f63a5bffca30140cadb8d2c1591f94aecd2bb.ogg",
      "bytes": 252257,
      "served": true,
      "seconds": 45,
      "channels": 1,
      "sampleRate": 48000,
      "from": 7.5,
      "gainDb": -5.53,
      "lufs": -24.4,
      "truePeak": -5.4,
      "loop": true
    },
    {
      "id": "overcast_soil_puresky_2k.hdr",
      "provider": "polyhaven",
      "asset": "overcast_soil_puresky",
      "kind": "hdri",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/HDRIs/hdr/2k/overcast_soil_puresky_2k.hdr",
      "md5": "877caf0680d7269037995f6567a67103",
      "sourceSha256": "5414e1ac0c35e451d28595b2a2cba05e2ca301fdeb755b0a469408443093dafc",
      "stored": "5414e1ac0c35e451d28595b2a2cba05e2ca301fdeb755b0a469408443093dafc.hdr",
      "bytes": 4568000,
      "served": true,
      "licence": "CC0-1.0",
      "worlds": [
        "polder"
      ],
      "width": 2048,
      "height": 1024,
      "sun": {
        "direction": [
          0.8044,
          0.5695,
          -0.169
        ],
        "azimuth": -11.9,
        "elevation": 34.7,
        "linear": [
          5.472,
          4.965,
          4.358
        ]
      },
      "horizon": "#dbd8d5",
      "horizonLinear": [
        0.8139,
        0.7458,
        0.6789
      ],
      "zenith": "#f1f1f1",
      "zenithLinear": [
        1.8505,
        1.8385,
        1.855
      ]
    },
    {
      "id": "pigeons-loop.ogg",
      "provider": "freesound",
      "asset": "pigeons",
      "kind": "audio",
      "sound": "pigeon walking and cooing.wav",
      "user": "5ro4",
      "page": "https://freesound.org/people/5ro4/sounds/701282/",
      "licence": "CC0-1.0",
      "worlds": [
        "town-square"
      ],
      "sourceUrl": "https://cdn.freesound.org/previews/701/701282_1629501-hq.ogg",
      "derivedFrom": "701282_1629501-hq.ogg",
      "sha256": "5f8228037f4e535627a6631f86afbb0a916f59fb838bc8310d5e0109bf8f1362",
      "stored": "5f8228037f4e535627a6631f86afbb0a916f59fb838bc8310d5e0109bf8f1362.ogg",
      "bytes": 176779,
      "served": true,
      "seconds": 30,
      "channels": 1,
      "sampleRate": 48000,
      "from": 0,
      "gainDb": -3.22,
      "lufs": -23.98,
      "truePeak": -3.17,
      "loop": true
    },
    {
      "id": "polder-larks-loop.ogg",
      "provider": "freesound",
      "asset": "polder-larks",
      "kind": "audio",
      "sound": "Larks and wind",
      "user": "Elanor1995",
      "page": "https://freesound.org/people/Elanor1995/sounds/688868/",
      "licence": "CC0-1.0",
      "worlds": [
        "polder"
      ],
      "sourceUrl": "https://cdn.freesound.org/previews/688/688868_6903350-hq.ogg",
      "derivedFrom": "688868_6903350-hq.ogg",
      "sha256": "7e8943941ba0429ff8cbc9d31020ae9375a9dbe86323ff31a8292ff75093eb96",
      "stored": "7e8943941ba0429ff8cbc9d31020ae9375a9dbe86323ff31a8292ff75093eb96.ogg",
      "bytes": 251076,
      "served": true,
      "seconds": 45,
      "channels": 1,
      "sampleRate": 48000,
      "from": 103.5,
      "gainDb": 28.85,
      "lufs": -24.72,
      "truePeak": -5.32,
      "loop": true
    },
    {
      "id": "potted_plant_04.bin",
      "provider": "polyhaven",
      "asset": "potted_plant_04",
      "kind": "bin",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/gltf/8k/potted_plant_04/potted_plant_04.bin",
      "md5": "03774ca8e28e2aa30fb26cb68d5e0093",
      "sourceSha256": "158c1d27503d4845eb3573f00c01ae3f4f77f1d6ca8754c67bf1762745946f7f",
      "stored": "158c1d27503d4845eb3573f00c01ae3f4f77f1d6ca8754c67bf1762745946f7f.bin",
      "bytes": 241800,
      "served": true,
      "licence": "CC0-1.0",
      "worlds": [
        "museum-hall",
        "science-lab"
      ]
    },
    {
      "id": "potted_plant_04.gltf",
      "provider": "polyhaven",
      "asset": "potted_plant_04",
      "kind": "gltf",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/gltf/1k/potted_plant_04/potted_plant_04_1k.gltf",
      "derivedFrom": "potted_plant_04_1k.gltf",
      "sha256": "ea31d61387704e8b86b41ac919c559a0dc5e385318d891954060622f89a6a8c8",
      "stored": "ea31d61387704e8b86b41ac919c559a0dc5e385318d891954060622f89a6a8c8.gltf",
      "bytes": 4348,
      "served": true,
      "licence": "CC0-1.0",
      "worlds": [
        "museum-hall",
        "science-lab"
      ],
      "triangles": 8929,
      "primitives": 4,
      "materials": 1,
      "bounds": {
        "min": [
          -0.0839,
          0.0004,
          -0.0839
        ],
        "max": [
          0.0839,
          0.2678,
          0.1008
        ]
      },
      "requires": [
        "158c1d27503d4845eb3573f00c01ae3f4f77f1d6ca8754c67bf1762745946f7f.bin",
        "26406c467c64e107cd1aeccc7f84496239180eb0698f680bc99ae58511eff109.jpg",
        "77e19c57a1021f87b54636292a17ba6727a8bf0f672c27e4bdd901ed09b4cff9.jpg",
        "b27a65147d2738e96a4d947d673d1a55ac83ea7a28327d5a3804dc7dde8c4cb3.jpg"
      ],
      "resizedTo": 512
    },
    {
      "id": "potted_plant_04_1k.gltf",
      "provider": "polyhaven",
      "asset": "potted_plant_04",
      "kind": "gltf",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/gltf/1k/potted_plant_04/potted_plant_04_1k.gltf",
      "md5": "077d481764145f6e5e256593aab427bb",
      "sourceSha256": "b3a3bc3e97da75844999c4da07b7104b6c023f729a7c045979929b9504184339",
      "stored": "b3a3bc3e97da75844999c4da07b7104b6c023f729a7c045979929b9504184339.gltf",
      "bytes": 7081,
      "served": false,
      "licence": "CC0-1.0",
      "worlds": [
        "science-lab"
      ],
      "triangles": 8929,
      "primitives": 4,
      "materials": 1,
      "bounds": {
        "min": [
          -0.0839,
          0.0004,
          -0.0839
        ],
        "max": [
          0.0839,
          0.2678,
          0.1008
        ]
      }
    },
    {
      "id": "potted_plant_04_arm_1k.jpg",
      "provider": "polyhaven",
      "asset": "potted_plant_04",
      "kind": "texture",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/jpg/1k/potted_plant_04/potted_plant_04_arm_1k.jpg",
      "md5": "ed0030c6085bba45b6f63f3043b0b237",
      "sourceSha256": "7f3288345570ef700c851ea382ed267490ffc8c901ccc31f2ec5507e4d098e48",
      "stored": "7f3288345570ef700c851ea382ed267490ffc8c901ccc31f2ec5507e4d098e48.jpg",
      "bytes": 478413,
      "served": false,
      "licence": "CC0-1.0",
      "worlds": [
        "science-lab"
      ],
      "width": 1024,
      "height": 1024,
      "averageColour": "#7f8101"
    },
    {
      "id": "potted_plant_04_arm_512.jpg",
      "provider": "polyhaven",
      "asset": "potted_plant_04",
      "kind": "texture",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/jpg/1k/potted_plant_04/potted_plant_04_arm_1k.jpg",
      "derivedFrom": "potted_plant_04_arm_1k.jpg",
      "sha256": "b27a65147d2738e96a4d947d673d1a55ac83ea7a28327d5a3804dc7dde8c4cb3",
      "stored": "b27a65147d2738e96a4d947d673d1a55ac83ea7a28327d5a3804dc7dde8c4cb3.jpg",
      "bytes": 40718,
      "served": true,
      "licence": "CC0-1.0",
      "worlds": [
        "museum-hall",
        "science-lab"
      ],
      "width": 512,
      "height": 512,
      "averageColour": "#7f8102"
    },
    {
      "id": "potted_plant_04_diff_1k.jpg",
      "provider": "polyhaven",
      "asset": "potted_plant_04",
      "kind": "texture",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/jpg/1k/potted_plant_04/potted_plant_04_diff_1k.jpg",
      "md5": "4a72fb3667fd3686ca4014f6676f59c4",
      "sourceSha256": "8693a971557fbafb12a24a2e23c1a04ab6b04ecdc4d26808c5ad3516a4971f24",
      "stored": "8693a971557fbafb12a24a2e23c1a04ab6b04ecdc4d26808c5ad3516a4971f24.jpg",
      "bytes": 577545,
      "served": false,
      "licence": "CC0-1.0",
      "worlds": [
        "science-lab"
      ],
      "width": 1024,
      "height": 1024,
      "averageColour": "#7f7963"
    },
    {
      "id": "potted_plant_04_diff_512.jpg",
      "provider": "polyhaven",
      "asset": "potted_plant_04",
      "kind": "texture",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/jpg/1k/potted_plant_04/potted_plant_04_diff_1k.jpg",
      "derivedFrom": "potted_plant_04_diff_1k.jpg",
      "sha256": "77e19c57a1021f87b54636292a17ba6727a8bf0f672c27e4bdd901ed09b4cff9",
      "stored": "77e19c57a1021f87b54636292a17ba6727a8bf0f672c27e4bdd901ed09b4cff9.jpg",
      "bytes": 52114,
      "served": true,
      "licence": "CC0-1.0",
      "worlds": [
        "museum-hall",
        "science-lab"
      ],
      "width": 512,
      "height": 512,
      "averageColour": "#7f7963"
    },
    {
      "id": "potted_plant_04_nor_gl_1k.jpg",
      "provider": "polyhaven",
      "asset": "potted_plant_04",
      "kind": "texture",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/jpg/1k/potted_plant_04/potted_plant_04_nor_gl_1k.jpg",
      "md5": "1c0b87906fd92c7b7ce5508110976474",
      "sourceSha256": "66e4627f6691a2d8104a6c53a39b41daddbd5bad8103e73f372c39166a3dcb07",
      "stored": "66e4627f6691a2d8104a6c53a39b41daddbd5bad8103e73f372c39166a3dcb07.jpg",
      "bytes": 817786,
      "served": false,
      "licence": "CC0-1.0",
      "worlds": [
        "science-lab"
      ],
      "width": 1024,
      "height": 1024,
      "averageColour": "#7c83ed"
    },
    {
      "id": "potted_plant_04_nor_gl_512.jpg",
      "provider": "polyhaven",
      "asset": "potted_plant_04",
      "kind": "texture",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/jpg/1k/potted_plant_04/potted_plant_04_nor_gl_1k.jpg",
      "derivedFrom": "potted_plant_04_nor_gl_1k.jpg",
      "sha256": "26406c467c64e107cd1aeccc7f84496239180eb0698f680bc99ae58511eff109",
      "stored": "26406c467c64e107cd1aeccc7f84496239180eb0698f680bc99ae58511eff109.jpg",
      "bytes": 72069,
      "served": true,
      "licence": "CC0-1.0",
      "worlds": [
        "museum-hall",
        "science-lab"
      ],
      "width": 512,
      "height": 512,
      "averageColour": "#7c83ec"
    },
    {
      "id": "quiver_tree_02.bin",
      "provider": "polyhaven",
      "asset": "quiver_tree_02",
      "kind": "bin",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/gltf/8k/quiver_tree_02/quiver_tree_02.bin",
      "md5": "63635d61c58151eb4fb0b2caaf6b373c",
      "sourceSha256": "fd3598b4aea34bc6864452d2dbb37a04e4bfa7ad1ab6062a3b97c485fae258f3",
      "stored": "fd3598b4aea34bc6864452d2dbb37a04e4bfa7ad1ab6062a3b97c485fae258f3.bin",
      "bytes": 2060604,
      "served": false,
      "licence": "CC0-1.0",
      "worlds": [
        "volcanic-island"
      ]
    },
    {
      "id": "quiver_tree_02.gltf",
      "provider": "polyhaven",
      "asset": "quiver_tree_02",
      "kind": "gltf",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/gltf/1k/quiver_tree_02/quiver_tree_02_1k.gltf",
      "derivedFrom": "quiver_tree_02_1k.gltf",
      "sha256": "4803ec850623bb4d552b18a18075ba4a77af56a6a4dbf002e6e5076a9242724e",
      "stored": "4803ec850623bb4d552b18a18075ba4a77af56a6a4dbf002e6e5076a9242724e.gltf",
      "bytes": 1440,
      "served": true,
      "licence": "CC0-1.0",
      "worlds": [
        "volcanic-island"
      ],
      "triangles": 3999,
      "primitives": 1,
      "materials": 1,
      "bounds": {
        "min": [
          -0.4818,
          -0.0463,
          -0.4268
        ],
        "max": [
          0.381,
          1.4185,
          0.4484
        ]
      },
      "requires": [
        "084723f84e637f747792a13491d292f84e9ca104c5749f30ab270373653440f9.bin",
        "810a4cf447d75f0c3225dd4e2f7f78f567837d507b014f54364599e426befa3a.jpg"
      ],
      "simplifiedFrom": 82074,
      "variants": [
        {
          "name": "quiver_tree_02",
          "triangles": 3999,
          "size": [
            0.863,
            1.465,
            0.875
          ]
        }
      ],
      "resizedTo": 512
    },
    {
      "id": "quiver_tree_02_1k.gltf",
      "provider": "polyhaven",
      "asset": "quiver_tree_02",
      "kind": "gltf",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/gltf/1k/quiver_tree_02/quiver_tree_02_1k.gltf",
      "md5": "1002e67d6921204df06b9a97f4f30cff",
      "sourceSha256": "c92ea2f60defaa9c134f43ac606bb7564ade348f92b546ba91c87bc6365d1a56",
      "stored": "c92ea2f60defaa9c134f43ac606bb7564ade348f92b546ba91c87bc6365d1a56.gltf",
      "bytes": 2809,
      "served": false,
      "licence": "CC0-1.0",
      "worlds": [
        "volcanic-island"
      ],
      "triangles": 82074,
      "primitives": 1,
      "materials": 1,
      "bounds": {
        "min": [
          -0.4839,
          -0.0493,
          -0.432
        ],
        "max": [
          0.3877,
          1.4196,
          0.4488
        ]
      }
    },
    {
      "id": "quiver_tree_02_diff_1k.jpg",
      "provider": "polyhaven",
      "asset": "quiver_tree_02",
      "kind": "texture",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/jpg/1k/quiver_tree_02/quiver_tree_02_diff_1k.jpg",
      "md5": "7f14325c48fc30112476b851d7e05232",
      "sourceSha256": "546a745ad765529d3c310178321e145909f4817b06679788ad24d29ec7eae7b7",
      "stored": "546a745ad765529d3c310178321e145909f4817b06679788ad24d29ec7eae7b7.jpg",
      "bytes": 736321,
      "served": false,
      "licence": "CC0-1.0",
      "worlds": [
        "volcanic-island"
      ],
      "width": 1024,
      "height": 1024,
      "averageColour": "#59543b"
    },
    {
      "id": "quiver_tree_02_diff_512.jpg",
      "provider": "polyhaven",
      "asset": "quiver_tree_02",
      "kind": "texture",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/jpg/1k/quiver_tree_02/quiver_tree_02_diff_1k.jpg",
      "derivedFrom": "quiver_tree_02_diff_1k.jpg",
      "sha256": "810a4cf447d75f0c3225dd4e2f7f78f567837d507b014f54364599e426befa3a",
      "stored": "810a4cf447d75f0c3225dd4e2f7f78f567837d507b014f54364599e426befa3a.jpg",
      "bytes": 61909,
      "served": true,
      "licence": "CC0-1.0",
      "worlds": [
        "volcanic-island"
      ],
      "width": 512,
      "height": 512,
      "averageColour": "#59543b"
    },
    {
      "id": "quiver_tree_02_simplified.bin",
      "provider": "polyhaven",
      "asset": "quiver_tree_02",
      "kind": "bin",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/gltf/8k/quiver_tree_02/quiver_tree_02.bin",
      "derivedFrom": "quiver_tree_02.bin",
      "sha256": "084723f84e637f747792a13491d292f84e9ca104c5749f30ab270373653440f9",
      "stored": "084723f84e637f747792a13491d292f84e9ca104c5749f30ab270373653440f9.bin",
      "bytes": 136060,
      "served": true,
      "licence": "CC0-1.0",
      "worlds": [
        "volcanic-island"
      ]
    },
    {
      "id": "red_brick_03_diff_1k.jpg",
      "provider": "polyhaven",
      "asset": "red_brick_03",
      "kind": "texture",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Textures/jpg/1k/red_brick_03/red_brick_03_diff_1k.jpg",
      "md5": "d157c6d6dd774762b4269927a87fe9b5",
      "sourceSha256": "9c58254c099b2d211478f50a427fcdde622af24249ff2e94da41fb836f8c857f",
      "stored": "9c58254c099b2d211478f50a427fcdde622af24249ff2e94da41fb836f8c857f.jpg",
      "bytes": 694500,
      "served": true,
      "licence": "CC0-1.0",
      "worlds": [
        "town-square"
      ],
      "width": 1024,
      "height": 1024,
      "averageColour": "#6a534b"
    },
    {
      "id": "red_brick_03_nor_gl_1k.jpg",
      "provider": "polyhaven",
      "asset": "red_brick_03",
      "kind": "texture",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Textures/jpg/1k/red_brick_03/red_brick_03_nor_gl_1k.jpg",
      "md5": "e89ce432d9160edb7c902f901756865f",
      "sourceSha256": "9bfd45e24720d851017c1e1678b70219c72239b2ac6b25e11d57d458bdab8503",
      "stored": "9bfd45e24720d851017c1e1678b70219c72239b2ac6b25e11d57d458bdab8503.jpg",
      "bytes": 955430,
      "served": true,
      "licence": "CC0-1.0",
      "worlds": [
        "town-square"
      ],
      "width": 1024,
      "height": 1024,
      "averageColour": "#7777f4"
    },
    {
      "id": "rock_07.bin",
      "provider": "polyhaven",
      "asset": "rock_07",
      "kind": "bin",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/gltf/8k/rock_07/rock_07.bin",
      "md5": "817b2cfd1626cb06f18a825f87f58ec3",
      "sourceSha256": "e4a532a6d6cf4a08c288f501b790f32cba0528136a29959ce774c3cd39369e7e",
      "stored": "e4a532a6d6cf4a08c288f501b790f32cba0528136a29959ce774c3cd39369e7e.bin",
      "bytes": 468936,
      "served": true,
      "licence": "CC0-1.0",
      "worlds": [
        "sea-floor",
        "volcanic-island"
      ]
    },
    {
      "id": "rock_07.gltf",
      "provider": "polyhaven",
      "asset": "rock_07",
      "kind": "gltf",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/gltf/1k/rock_07/rock_07_1k.gltf",
      "derivedFrom": "rock_07_1k.gltf",
      "sha256": "c4ee7a290c51d010ed677f2ce3e043a6273e5b266d37afab68fe3230cf3239c8",
      "stored": "c4ee7a290c51d010ed677f2ce3e043a6273e5b266d37afab68fe3230cf3239c8.gltf",
      "bytes": 1965,
      "served": true,
      "licence": "CC0-1.0",
      "worlds": [
        "sea-floor",
        "volcanic-island"
      ],
      "triangles": 14844,
      "primitives": 1,
      "materials": 1,
      "bounds": {
        "min": [
          -0.0876,
          -0.0019,
          -0.178
        ],
        "max": [
          0.0813,
          0.1418,
          0.1423
        ]
      },
      "requires": [
        "2b7d4295ebcb55175503d33a113c6a64964f031aed26f6106e85b88365d7cee8.jpg",
        "3f42174c517fec7757aa7bb46166a1cc15f9ad8b44ef220acbc7f6d1535ff771.jpg",
        "625515df1d9a37002dbb74989c7a1c0b4e27c8c8e5d37eba183830db0e8bf02d.jpg",
        "e4a532a6d6cf4a08c288f501b790f32cba0528136a29959ce774c3cd39369e7e.bin"
      ],
      "resizedTo": 512
    },
    {
      "id": "rock_07_1k.gltf",
      "provider": "polyhaven",
      "asset": "rock_07",
      "kind": "gltf",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/gltf/1k/rock_07/rock_07_1k.gltf",
      "md5": "2bdb563c126a9d284e60e94951759e2f",
      "sourceSha256": "efcc2dcaa133ff8ad5c865dc2135772e8f5dbc83fa38db2ee2cf25382436b6e6",
      "stored": "efcc2dcaa133ff8ad5c865dc2135772e8f5dbc83fa38db2ee2cf25382436b6e6.gltf",
      "bytes": 2979,
      "served": false,
      "licence": "CC0-1.0",
      "worlds": [
        "volcanic-island"
      ],
      "triangles": 14844,
      "primitives": 1,
      "materials": 1,
      "bounds": {
        "min": [
          -0.0876,
          -0.0019,
          -0.178
        ],
        "max": [
          0.0813,
          0.1418,
          0.1423
        ]
      }
    },
    {
      "id": "rock_07_arm_1k.jpg",
      "provider": "polyhaven",
      "asset": "rock_07",
      "kind": "texture",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/jpg/1k/rock_07/rock_07_arm_1k.jpg",
      "md5": "530bfd2a510fe6f778bb1198a2395574",
      "sourceSha256": "1ed76e9a8542c76bdc6b7b018720ae1f52cd75d9f5ae719f613de3f5032cf4da",
      "stored": "1ed76e9a8542c76bdc6b7b018720ae1f52cd75d9f5ae719f613de3f5032cf4da.jpg",
      "bytes": 309735,
      "served": false,
      "licence": "CC0-1.0",
      "worlds": [
        "volcanic-island"
      ],
      "width": 1024,
      "height": 1024,
      "averageColour": "#ce4c00"
    },
    {
      "id": "rock_07_arm_512.jpg",
      "provider": "polyhaven",
      "asset": "rock_07",
      "kind": "texture",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/jpg/1k/rock_07/rock_07_arm_1k.jpg",
      "derivedFrom": "rock_07_arm_1k.jpg",
      "sha256": "2b7d4295ebcb55175503d33a113c6a64964f031aed26f6106e85b88365d7cee8",
      "stored": "2b7d4295ebcb55175503d33a113c6a64964f031aed26f6106e85b88365d7cee8.jpg",
      "bytes": 24949,
      "served": true,
      "licence": "CC0-1.0",
      "worlds": [
        "sea-floor",
        "volcanic-island"
      ],
      "width": 512,
      "height": 512,
      "averageColour": "#ce4c01"
    },
    {
      "id": "rock_07_diff_1k.jpg",
      "provider": "polyhaven",
      "asset": "rock_07",
      "kind": "texture",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/jpg/1k/rock_07/rock_07_diff_1k.jpg",
      "md5": "b68ac1824bb3bd3867641b830ad02099",
      "sourceSha256": "8ff1965aa1664cc4abcc0131c44ee2b97ab14d6e131d7a51429ff261eeb101c8",
      "stored": "8ff1965aa1664cc4abcc0131c44ee2b97ab14d6e131d7a51429ff261eeb101c8.jpg",
      "bytes": 635452,
      "served": false,
      "licence": "CC0-1.0",
      "worlds": [
        "volcanic-island"
      ],
      "width": 1024,
      "height": 1024,
      "averageColour": "#745c46"
    },
    {
      "id": "rock_07_diff_512.jpg",
      "provider": "polyhaven",
      "asset": "rock_07",
      "kind": "texture",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/jpg/1k/rock_07/rock_07_diff_1k.jpg",
      "derivedFrom": "rock_07_diff_1k.jpg",
      "sha256": "3f42174c517fec7757aa7bb46166a1cc15f9ad8b44ef220acbc7f6d1535ff771",
      "stored": "3f42174c517fec7757aa7bb46166a1cc15f9ad8b44ef220acbc7f6d1535ff771.jpg",
      "bytes": 49637,
      "served": true,
      "licence": "CC0-1.0",
      "worlds": [
        "sea-floor",
        "volcanic-island"
      ],
      "width": 512,
      "height": 512,
      "averageColour": "#745c46"
    },
    {
      "id": "rock_07_nor_gl_1k.jpg",
      "provider": "polyhaven",
      "asset": "rock_07",
      "kind": "texture",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/jpg/1k/rock_07/rock_07_nor_gl_1k.jpg",
      "md5": "d3a2a0df0db0177c4df8ef644b003652",
      "sourceSha256": "57cb2210951aeb376164fce5f7c65f03e5599def04873b56cad0f173c275d78d",
      "stored": "57cb2210951aeb376164fce5f7c65f03e5599def04873b56cad0f173c275d78d.jpg",
      "bytes": 766986,
      "served": false,
      "licence": "CC0-1.0",
      "worlds": [
        "volcanic-island"
      ],
      "width": 1024,
      "height": 1024,
      "averageColour": "#8280fa"
    },
    {
      "id": "rock_07_nor_gl_512.jpg",
      "provider": "polyhaven",
      "asset": "rock_07",
      "kind": "texture",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/jpg/1k/rock_07/rock_07_nor_gl_1k.jpg",
      "derivedFrom": "rock_07_nor_gl_1k.jpg",
      "sha256": "625515df1d9a37002dbb74989c7a1c0b4e27c8c8e5d37eba183830db0e8bf02d",
      "stored": "625515df1d9a37002dbb74989c7a1c0b4e27c8c8e5d37eba183830db0e8bf02d.jpg",
      "bytes": 59192,
      "served": true,
      "licence": "CC0-1.0",
      "worlds": [
        "sea-floor",
        "volcanic-island"
      ],
      "width": 512,
      "height": 512,
      "averageColour": "#8280f9"
    },
    {
      "id": "shrub_02.bin",
      "provider": "polyhaven",
      "asset": "shrub_02",
      "kind": "bin",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/gltf/4k/shrub_02/shrub_02.bin",
      "md5": "683b5475238310899eac1458520903e6",
      "sourceSha256": "5c1b79da1cfdbac90599542ccd1f75ba433a3a4d356b1ea03655adb39b0e2c96",
      "stored": "5c1b79da1cfdbac90599542ccd1f75ba433a3a4d356b1ea03655adb39b0e2c96.bin",
      "bytes": 758692,
      "served": false,
      "licence": "CC0-1.0",
      "worlds": [
        "volcanic-island"
      ]
    },
    {
      "id": "shrub_02.gltf",
      "provider": "polyhaven",
      "asset": "shrub_02",
      "kind": "gltf",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/gltf/1k/shrub_02/shrub_02_1k.gltf",
      "derivedFrom": "shrub_02_1k.gltf",
      "sha256": "7688acac681e3078e3b17a4ba02ab43938f12bb3c518387a619ef98dee9c7ccf",
      "stored": "7688acac681e3078e3b17a4ba02ab43938f12bb3c518387a619ef98dee9c7ccf.gltf",
      "bytes": 4242,
      "served": true,
      "licence": "CC0-1.0",
      "worlds": [
        "forest",
        "volcanic-island"
      ],
      "triangles": 3854,
      "primitives": 4,
      "materials": 1,
      "bounds": {
        "min": [
          -2.3021,
          -0.6064,
          -1.1912
        ],
        "max": [
          4.2638,
          1.9413,
          1.3448
        ]
      },
      "requires": [
        "7d41d79ff4d9bb9c8581534f17931886fd63b33ebcd4d35b9a7efdc2580dd3e8.bin",
        "84d37d7a7e572121daa77e87b429f02942d235df166017168f44d94099ae5eb0.jpg"
      ],
      "simplifiedFrom": 27254,
      "variants": [
        {
          "name": "shrub_02_a",
          "triangles": 1064,
          "size": [
            1.626,
            2.151,
            1.83
          ]
        },
        {
          "name": "shrub_02_b",
          "triangles": 746,
          "size": [
            2.06,
            1.949,
            1.816
          ]
        },
        {
          "name": "shrub_02_c",
          "triangles": 1314,
          "size": [
            2.483,
            2.381,
            2.536
          ]
        },
        {
          "name": "shrub_02_d",
          "triangles": 730,
          "size": [
            1.607,
            1.938,
            1.809
          ]
        }
      ],
      "resizedTo": 512
    },
    {
      "id": "shrub_02_1k.gltf",
      "provider": "polyhaven",
      "asset": "shrub_02",
      "kind": "gltf",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/gltf/1k/shrub_02/shrub_02_1k.gltf",
      "md5": "8f7254d279c0c49c0b3edfe260aa5c86",
      "sourceSha256": "99de0a70fe88ad414615cc8d8e020617c8512e2abfe08b911b153a6fcc40d93e",
      "stored": "99de0a70fe88ad414615cc8d8e020617c8512e2abfe08b911b153a6fcc40d93e.gltf",
      "bytes": 8083,
      "served": false,
      "licence": "CC0-1.0",
      "worlds": [
        "volcanic-island"
      ],
      "triangles": 27254,
      "primitives": 4,
      "materials": 1,
      "bounds": {
        "min": [
          -2.3085,
          -0.6064,
          -1.1912
        ],
        "max": [
          4.2642,
          1.9417,
          1.3448
        ]
      }
    },
    {
      "id": "shrub_02_alpha_1k.png",
      "provider": "polyhaven",
      "asset": "shrub_02",
      "kind": "texture",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/png/1k/shrub_02/shrub_02_alpha_1k.png",
      "md5": "64a1f609d80ea076b43412498a3d2db5",
      "sourceSha256": "5c2c31bac311051db77443e1780078403c2df0a832c40fe6ed7bcd982695cdf0",
      "stored": "5c2c31bac311051db77443e1780078403c2df0a832c40fe6ed7bcd982695cdf0.png",
      "bytes": 91741,
      "served": false,
      "licence": "CC0-1.0",
      "worlds": [
        "volcanic-island"
      ],
      "width": 1024,
      "height": 1024,
      "averageColour": "#5886"
    },
    {
      "id": "shrub_02_diff_1k.jpg",
      "provider": "polyhaven",
      "asset": "shrub_02",
      "kind": "texture",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/jpg/1k/shrub_02/shrub_02_diff_1k.jpg",
      "md5": "3f4ae281928de030c7d4e41ad5b88a8b",
      "sourceSha256": "9956eff294034d70516d867e9668428a23d782feb3d4c34061dce5e44bacd5a8",
      "stored": "9956eff294034d70516d867e9668428a23d782feb3d4c34061dce5e44bacd5a8.jpg",
      "bytes": 395120,
      "served": false,
      "licence": "CC0-1.0",
      "worlds": [
        "volcanic-island"
      ],
      "width": 1024,
      "height": 1024,
      "averageColour": "#5d5039"
    },
    {
      "id": "shrub_02_diff_512.png",
      "provider": "polyhaven",
      "asset": "shrub_02",
      "kind": "texture",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/jpg/1k/shrub_02/shrub_02_diff_1k.jpg",
      "derivedFrom": "shrub_02_diff_1k.jpg",
      "sha256": "84d37d7a7e572121daa77e87b429f02942d235df166017168f44d94099ae5eb0",
      "stored": "84d37d7a7e572121daa77e87b429f02942d235df166017168f44d94099ae5eb0.jpg",
      "bytes": 440954,
      "served": true,
      "licence": "CC0-1.0",
      "worlds": [
        "forest",
        "volcanic-island"
      ],
      "width": 512,
      "height": 512,
      "averageColour": "#5d5039"
    },
    {
      "id": "shrub_02_simplified.bin",
      "provider": "polyhaven",
      "asset": "shrub_02",
      "kind": "bin",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/gltf/4k/shrub_02/shrub_02.bin",
      "derivedFrom": "shrub_02.bin",
      "sha256": "7d41d79ff4d9bb9c8581534f17931886fd63b33ebcd4d35b9a7efdc2580dd3e8",
      "stored": "7d41d79ff4d9bb9c8581534f17931886fd63b33ebcd4d35b9a7efdc2580dd3e8.bin",
      "bytes": 157748,
      "served": true,
      "licence": "CC0-1.0",
      "worlds": [
        "forest",
        "volcanic-island"
      ]
    },
    {
      "id": "shrub_03.bin",
      "provider": "polyhaven",
      "asset": "shrub_03",
      "kind": "bin",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/gltf/4k/shrub_03/shrub_03.bin",
      "md5": "c26c6ed23b0034664eab5a0e3ee00f6a",
      "sourceSha256": "bf4df21e6d2a2bc5f00b4c9142f776171fe7da00cf960001825748067af542b6",
      "stored": "bf4df21e6d2a2bc5f00b4c9142f776171fe7da00cf960001825748067af542b6.bin",
      "bytes": 238684,
      "served": false,
      "licence": "CC0-1.0",
      "worlds": [
        "volcanic-island"
      ]
    },
    {
      "id": "shrub_03.gltf",
      "provider": "polyhaven",
      "asset": "shrub_03",
      "kind": "gltf",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/gltf/1k/shrub_03/shrub_03_1k.gltf",
      "derivedFrom": "shrub_03_1k.gltf",
      "sha256": "2094af58e9822354df7de56f92afd3f20394e5775c300bc3c8dafde53d1c39f9",
      "stored": "2094af58e9822354df7de56f92afd3f20394e5775c300bc3c8dafde53d1c39f9.gltf",
      "bytes": 3697,
      "served": true,
      "licence": "CC0-1.0",
      "worlds": [
        "forest",
        "volcanic-island"
      ],
      "triangles": 1994,
      "primitives": 4,
      "materials": 1,
      "bounds": {
        "min": [
          -0.0735,
          -0.0018,
          -0.0727
        ],
        "max": [
          1.2931,
          0.401,
          0.0785
        ]
      },
      "requires": [
        "11a2d2ea4199b0db1b9f3b247ab4340133ef283a8f036bdfaff08cc650878daa.bin",
        "463086aa00784eef05fb5deb0a37b5269813ee72233cab56a0e1795493eb889f.jpg"
      ],
      "simplifiedFrom": 8287,
      "variants": [
        {
          "name": "shrub_03_a",
          "triangles": 573,
          "size": [
            0.201,
            0.403,
            0.151
          ]
        },
        {
          "name": "shrub_03_b",
          "triangles": 513,
          "size": [
            0.184,
            0.353,
            0.123
          ]
        },
        {
          "name": "shrub_03_c",
          "triangles": 432,
          "size": [
            0.096,
            0.304,
            0.113
          ]
        },
        {
          "name": "shrub_03_d",
          "triangles": 476,
          "size": [
            0.112,
            0.256,
            0.089
          ]
        }
      ],
      "resizedTo": 512
    },
    {
      "id": "shrub_03_1k.gltf",
      "provider": "polyhaven",
      "asset": "shrub_03",
      "kind": "gltf",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/gltf/1k/shrub_03/shrub_03_1k.gltf",
      "md5": "2c1ef10ff17e23f81d29c851d1409c9a",
      "sourceSha256": "b76d7c14bc027e834e82d3f984c32b5d060e62908aa90ff9420a637ca253a8ea",
      "stored": "b76d7c14bc027e834e82d3f984c32b5d060e62908aa90ff9420a637ca253a8ea.gltf",
      "bytes": 7296,
      "served": false,
      "licence": "CC0-1.0",
      "worlds": [
        "volcanic-island"
      ],
      "triangles": 8287,
      "primitives": 4,
      "materials": 1,
      "bounds": {
        "min": [
          -0.0735,
          -0.0018,
          -0.0727
        ],
        "max": [
          1.2934,
          0.401,
          0.0785
        ]
      }
    },
    {
      "id": "shrub_03_alpha_1k.png",
      "provider": "polyhaven",
      "asset": "shrub_03",
      "kind": "texture",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/png/1k/shrub_03/shrub_03_alpha_1k.png",
      "md5": "57a2d0fd7ea02ebeb8de321652f9f58a",
      "sourceSha256": "daef00278879a024fd05216aaa1376067a5f25f1b911d08d9bbdc50fda4a0d66",
      "stored": "daef00278879a024fd05216aaa1376067a5f25f1b911d08d9bbdc50fda4a0d66.png",
      "bytes": 79069,
      "served": false,
      "licence": "CC0-1.0",
      "worlds": [
        "volcanic-island"
      ],
      "width": 1024,
      "height": 1024,
      "averageColour": "#4041"
    },
    {
      "id": "shrub_03_diff_1k.jpg",
      "provider": "polyhaven",
      "asset": "shrub_03",
      "kind": "texture",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/jpg/1k/shrub_03/shrub_03_diff_1k.jpg",
      "md5": "5da9190b7c2837a9e209a3fe774dba3c",
      "sourceSha256": "3cadc7aba46d3aabbd7d6d2b1d04aa32e2a7da0bc87c2d38ef3cb1ee42cb03ec",
      "stored": "3cadc7aba46d3aabbd7d6d2b1d04aa32e2a7da0bc87c2d38ef3cb1ee42cb03ec.jpg",
      "bytes": 481841,
      "served": false,
      "licence": "CC0-1.0",
      "worlds": [
        "volcanic-island"
      ],
      "width": 1024,
      "height": 1024,
      "averageColour": "#736c3b"
    },
    {
      "id": "shrub_03_diff_512.png",
      "provider": "polyhaven",
      "asset": "shrub_03",
      "kind": "texture",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/jpg/1k/shrub_03/shrub_03_diff_1k.jpg",
      "derivedFrom": "shrub_03_diff_1k.jpg",
      "sha256": "463086aa00784eef05fb5deb0a37b5269813ee72233cab56a0e1795493eb889f",
      "stored": "463086aa00784eef05fb5deb0a37b5269813ee72233cab56a0e1795493eb889f.jpg",
      "bytes": 533547,
      "served": true,
      "licence": "CC0-1.0",
      "worlds": [
        "forest",
        "volcanic-island"
      ],
      "width": 512,
      "height": 512,
      "averageColour": "#736c3b"
    },
    {
      "id": "shrub_03_simplified.bin",
      "provider": "polyhaven",
      "asset": "shrub_03",
      "kind": "bin",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/gltf/4k/shrub_03/shrub_03.bin",
      "derivedFrom": "shrub_03.bin",
      "sha256": "11a2d2ea4199b0db1b9f3b247ab4340133ef283a8f036bdfaff08cc650878daa",
      "stored": "11a2d2ea4199b0db1b9f3b247ab4340133ef283a8f036bdfaff08cc650878daa.bin",
      "bytes": 79136,
      "served": true,
      "licence": "CC0-1.0",
      "worlds": [
        "forest",
        "volcanic-island"
      ]
    },
    {
      "id": "steel_frame_shelves_01.bin",
      "provider": "polyhaven",
      "asset": "steel_frame_shelves_01",
      "kind": "bin",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/gltf/8k/steel_frame_shelves_01/steel_frame_shelves_01.bin",
      "md5": "5728ceb7ff0d9b0b5ba5e7ef970aced9",
      "sourceSha256": "306d7e72d12a5d3047b8a189f8d0add51075eaf7f51f935286fda4e1c16dd066",
      "stored": "306d7e72d12a5d3047b8a189f8d0add51075eaf7f51f935286fda4e1c16dd066.bin",
      "bytes": 142312,
      "served": true,
      "licence": "CC0-1.0",
      "worlds": [
        "science-lab"
      ]
    },
    {
      "id": "steel_frame_shelves_01.gltf",
      "provider": "polyhaven",
      "asset": "steel_frame_shelves_01",
      "kind": "gltf",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/gltf/1k/steel_frame_shelves_01/steel_frame_shelves_01_1k.gltf",
      "derivedFrom": "steel_frame_shelves_01_1k.gltf",
      "sha256": "9f3bc187cb04478585fa320fa06f68c06af1ac2fc6caf9171d53a1a17dee7de3",
      "stored": "9f3bc187cb04478585fa320fa06f68c06af1ac2fc6caf9171d53a1a17dee7de3.gltf",
      "bytes": 1832,
      "served": true,
      "licence": "CC0-1.0",
      "worlds": [
        "science-lab"
      ],
      "triangles": 4348,
      "primitives": 1,
      "materials": 1,
      "bounds": {
        "min": [
          -5.4869,
          -0.0107,
          -2.5106
        ],
        "max": [
          5.4873,
          21.3943,
          2.5106
        ]
      },
      "requires": [
        "2a67ed7dd4f53c3e225396e6381992b768fe58b5261be703d540678e366e46ed.jpg",
        "306d7e72d12a5d3047b8a189f8d0add51075eaf7f51f935286fda4e1c16dd066.bin",
        "858629eeaa8f68ddb4fc1a813afe6ed988ded3d6d49184ec45a14611760f0bb3.jpg",
        "85e205b334e15e05bec9b02be1258da6ab949ae908aa57e0bee6b94ba45b4415.jpg"
      ]
    },
    {
      "id": "steel_frame_shelves_01_1k.gltf",
      "provider": "polyhaven",
      "asset": "steel_frame_shelves_01",
      "kind": "gltf",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/gltf/1k/steel_frame_shelves_01/steel_frame_shelves_01_1k.gltf",
      "md5": "36c93aa3e2757523e3f6336d628033ff",
      "sourceSha256": "4eff8994825d654e337f8dc425e959ed6add7f4773188c87ba64402d9edd9842",
      "stored": "4eff8994825d654e337f8dc425e959ed6add7f4773188c87ba64402d9edd9842.gltf",
      "bytes": 2766,
      "served": false,
      "licence": "CC0-1.0",
      "worlds": [
        "science-lab"
      ],
      "triangles": 4348,
      "primitives": 1,
      "materials": 1,
      "bounds": {
        "min": [
          -5.4869,
          -0.0107,
          -2.5106
        ],
        "max": [
          5.4873,
          21.3943,
          2.5106
        ]
      }
    },
    {
      "id": "steel_frame_shelves_01_arm_1k.jpg",
      "provider": "polyhaven",
      "asset": "steel_frame_shelves_01",
      "kind": "texture",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/jpg/1k/steel_frame_shelves_01/steel_frame_shelves_01_arm_1k.jpg",
      "md5": "2adddc4cd4dc2be76c171791bb5338cd",
      "sourceSha256": "858629eeaa8f68ddb4fc1a813afe6ed988ded3d6d49184ec45a14611760f0bb3",
      "stored": "858629eeaa8f68ddb4fc1a813afe6ed988ded3d6d49184ec45a14611760f0bb3.jpg",
      "bytes": 655560,
      "served": true,
      "licence": "CC0-1.0",
      "worlds": [
        "science-lab"
      ],
      "width": 1024,
      "height": 1024,
      "averageColour": "#946e88"
    },
    {
      "id": "steel_frame_shelves_01_diff_1k.jpg",
      "provider": "polyhaven",
      "asset": "steel_frame_shelves_01",
      "kind": "texture",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/jpg/1k/steel_frame_shelves_01/steel_frame_shelves_01_diff_1k.jpg",
      "md5": "65520a03f0caf855bcb74a7842a0f937",
      "sourceSha256": "85e205b334e15e05bec9b02be1258da6ab949ae908aa57e0bee6b94ba45b4415",
      "stored": "85e205b334e15e05bec9b02be1258da6ab949ae908aa57e0bee6b94ba45b4415.jpg",
      "bytes": 477882,
      "served": true,
      "licence": "CC0-1.0",
      "worlds": [
        "science-lab"
      ],
      "width": 1024,
      "height": 1024,
      "averageColour": "#84694e"
    },
    {
      "id": "steel_frame_shelves_01_nor_gl_1k.jpg",
      "provider": "polyhaven",
      "asset": "steel_frame_shelves_01",
      "kind": "texture",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/jpg/1k/steel_frame_shelves_01/steel_frame_shelves_01_nor_gl_1k.jpg",
      "md5": "a87fd3930fc88524d1f43c23e2725fc0",
      "sourceSha256": "2a67ed7dd4f53c3e225396e6381992b768fe58b5261be703d540678e366e46ed",
      "stored": "2a67ed7dd4f53c3e225396e6381992b768fe58b5261be703d540678e366e46ed.jpg",
      "bytes": 318836,
      "served": true,
      "licence": "CC0-1.0",
      "worlds": [
        "science-lab"
      ],
      "width": 1024,
      "height": 1024,
      "averageColour": "#7e81ff"
    },
    {
      "id": "summer-meadow-loop.ogg",
      "provider": "freesound",
      "asset": "summer-meadow",
      "kind": "audio",
      "sound": "Summer meadow - Houghton Lodge",
      "user": "richwise",
      "page": "https://freesound.org/people/richwise/sounds/815552/",
      "licence": "CC0-1.0",
      "worlds": [
        "meadow"
      ],
      "sourceUrl": "https://cdn.freesound.org/previews/815/815552_1481531-hq.ogg",
      "derivedFrom": "815552_1481531-hq.ogg",
      "sha256": "f16cb256b69ddf291039ba2e2a1d90c025e6e5406ce539640109a57b419d91cf",
      "stored": "f16cb256b69ddf291039ba2e2a1d90c025e6e5406ce539640109a57b419d91cf.ogg",
      "bytes": 243587,
      "served": true,
      "seconds": 45,
      "channels": 1,
      "sampleRate": 48000,
      "from": 0,
      "gainDb": 12.05,
      "lufs": -24.59,
      "truePeak": -9.14,
      "loop": true
    },
    {
      "id": "wall_clock.bin",
      "provider": "polyhaven",
      "asset": "wall_clock",
      "kind": "bin",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/gltf/4k/wall_clock/wall_clock.bin",
      "md5": "f1399287d9ad2fa2cfb303e95bbdbc45",
      "sourceSha256": "61d9fe03e871508230160de546ef505f3f4405b1e82c167536945a483a8bb639",
      "stored": "61d9fe03e871508230160de546ef505f3f4405b1e82c167536945a483a8bb639.bin",
      "bytes": 132412,
      "served": true,
      "licence": "CC0-1.0",
      "worlds": [
        "museum-hall",
        "science-lab",
        "town-square"
      ]
    },
    {
      "id": "wall_clock.gltf",
      "provider": "polyhaven",
      "asset": "wall_clock",
      "kind": "gltf",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/gltf/1k/wall_clock/wall_clock_1k.gltf",
      "derivedFrom": "wall_clock_1k.gltf",
      "sha256": "ef69dcf12521a652c547413ea211bb2246a497c46b863568464f00a249643e51",
      "stored": "ef69dcf12521a652c547413ea211bb2246a497c46b863568464f00a249643e51.gltf",
      "bytes": 5539,
      "served": true,
      "licence": "CC0-1.0",
      "worlds": [
        "museum-hall",
        "science-lab",
        "town-square"
      ],
      "triangles": 3658,
      "primitives": 5,
      "materials": 2,
      "bounds": {
        "min": [
          -0.1602,
          -0.1602,
          0
        ],
        "max": [
          0.1602,
          0.1602,
          0.0472
        ]
      },
      "requires": [
        "10ad44bbf4a498dab3d25a88dfa615748b214ae4823895595c07ab32ee376201.jpg",
        "61d9fe03e871508230160de546ef505f3f4405b1e82c167536945a483a8bb639.bin",
        "68805f52b58d5a5a0ebc63bf1bb9ee617e668771177a4983a8579c560392e6d0.jpg",
        "68f0e3668bbcae59b20dc17dfc619ae5f298562597f5dee4e342cafe6b2f52d5.jpg",
        "958bcc764b99e726e60bd2f797c3a8b1888d882d05c4dc0a2fdca92543839257.jpg"
      ],
      "resizedTo": 512
    },
    {
      "id": "wall_clock_1k.gltf",
      "provider": "polyhaven",
      "asset": "wall_clock",
      "kind": "gltf",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/gltf/1k/wall_clock/wall_clock_1k.gltf",
      "md5": "86c50202813c717074d1bc72ddad9109",
      "sourceSha256": "4e67385443e808bc709c054c1de5be1e83d4bf07eb0893884c301fec0bae8bc6",
      "stored": "4e67385443e808bc709c054c1de5be1e83d4bf07eb0893884c301fec0bae8bc6.gltf",
      "bytes": 9008,
      "served": false,
      "licence": "CC0-1.0",
      "worlds": [
        "science-lab"
      ],
      "triangles": 3658,
      "primitives": 5,
      "materials": 2,
      "bounds": {
        "min": [
          -0.1602,
          -0.1602,
          0
        ],
        "max": [
          0.1602,
          0.1602,
          0.0472
        ]
      }
    },
    {
      "id": "wall_clock_arm_1k.jpg",
      "provider": "polyhaven",
      "asset": "wall_clock",
      "kind": "texture",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/jpg/1k/wall_clock/wall_clock_arm_1k.jpg",
      "md5": "6d962d1263bd5b34e16a69fa5473e8ac",
      "sourceSha256": "c78aabec7bb4af4fd6818be1099523e59bf12d88c872530b2260cdea08d81968",
      "stored": "c78aabec7bb4af4fd6818be1099523e59bf12d88c872530b2260cdea08d81968.jpg",
      "bytes": 444044,
      "served": false,
      "licence": "CC0-1.0",
      "worlds": [
        "science-lab"
      ],
      "width": 1024,
      "height": 1024,
      "averageColour": "#be5e70"
    },
    {
      "id": "wall_clock_arm_512.jpg",
      "provider": "polyhaven",
      "asset": "wall_clock",
      "kind": "texture",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/jpg/1k/wall_clock/wall_clock_arm_1k.jpg",
      "derivedFrom": "wall_clock_arm_1k.jpg",
      "sha256": "958bcc764b99e726e60bd2f797c3a8b1888d882d05c4dc0a2fdca92543839257",
      "stored": "958bcc764b99e726e60bd2f797c3a8b1888d882d05c4dc0a2fdca92543839257.jpg",
      "bytes": 41059,
      "served": true,
      "licence": "CC0-1.0",
      "worlds": [
        "museum-hall",
        "science-lab",
        "town-square"
      ],
      "width": 512,
      "height": 512,
      "averageColour": "#be5f70"
    },
    {
      "id": "wall_clock_diff_1k.jpg",
      "provider": "polyhaven",
      "asset": "wall_clock",
      "kind": "texture",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/jpg/1k/wall_clock/wall_clock_diff_1k.jpg",
      "md5": "32e8346296eebf4776e7e917f0080c7f",
      "sourceSha256": "012bfc3ceecd5e35679fe5764e33b6d1b8a631ad4fc9f5b267af25ad10468672",
      "stored": "012bfc3ceecd5e35679fe5764e33b6d1b8a631ad4fc9f5b267af25ad10468672.jpg",
      "bytes": 366683,
      "served": false,
      "licence": "CC0-1.0",
      "worlds": [
        "science-lab"
      ],
      "width": 1024,
      "height": 1024,
      "averageColour": "#848990"
    },
    {
      "id": "wall_clock_diff_512.jpg",
      "provider": "polyhaven",
      "asset": "wall_clock",
      "kind": "texture",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/jpg/1k/wall_clock/wall_clock_diff_1k.jpg",
      "derivedFrom": "wall_clock_diff_1k.jpg",
      "sha256": "68f0e3668bbcae59b20dc17dfc619ae5f298562597f5dee4e342cafe6b2f52d5",
      "stored": "68f0e3668bbcae59b20dc17dfc619ae5f298562597f5dee4e342cafe6b2f52d5.jpg",
      "bytes": 32979,
      "served": true,
      "licence": "CC0-1.0",
      "worlds": [
        "museum-hall",
        "science-lab",
        "town-square"
      ],
      "width": 512,
      "height": 512,
      "averageColour": "#848990"
    },
    {
      "id": "wall_clock_glass_arm_1k.jpg",
      "provider": "polyhaven",
      "asset": "wall_clock",
      "kind": "texture",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/jpg/1k/wall_clock/wall_clock_glass_arm_1k.jpg",
      "md5": "5e84b53fb7e087f4114de28d70787f5c",
      "sourceSha256": "42804955958b3d0fdc1da8d4c4e8e909b04f659ae1b02911e148abe0741b8b84",
      "stored": "42804955958b3d0fdc1da8d4c4e8e909b04f659ae1b02911e148abe0741b8b84.jpg",
      "bytes": 376244,
      "served": false,
      "licence": "CC0-1.0",
      "worlds": [
        "science-lab"
      ],
      "width": 1024,
      "height": 1024,
      "averageColour": "#fe0d00"
    },
    {
      "id": "wall_clock_glass_arm_512.jpg",
      "provider": "polyhaven",
      "asset": "wall_clock",
      "kind": "texture",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/jpg/1k/wall_clock/wall_clock_glass_arm_1k.jpg",
      "derivedFrom": "wall_clock_glass_arm_1k.jpg",
      "sha256": "68805f52b58d5a5a0ebc63bf1bb9ee617e668771177a4983a8579c560392e6d0",
      "stored": "68805f52b58d5a5a0ebc63bf1bb9ee617e668771177a4983a8579c560392e6d0.jpg",
      "bytes": 25709,
      "served": true,
      "licence": "CC0-1.0",
      "worlds": [
        "museum-hall",
        "science-lab",
        "town-square"
      ],
      "width": 512,
      "height": 512,
      "averageColour": "#fe0d01"
    },
    {
      "id": "wall_clock_nor_gl_1k.jpg",
      "provider": "polyhaven",
      "asset": "wall_clock",
      "kind": "texture",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/jpg/1k/wall_clock/wall_clock_nor_gl_1k.jpg",
      "md5": "d6404c2ffb48b17fbeed2cb9bf187a29",
      "sourceSha256": "6138946e055828e92d5e0d8d50c75e3d2da0ea789dd6512b30f85f0e18435d00",
      "stored": "6138946e055828e92d5e0d8d50c75e3d2da0ea789dd6512b30f85f0e18435d00.jpg",
      "bytes": 236489,
      "served": false,
      "licence": "CC0-1.0",
      "worlds": [
        "science-lab"
      ],
      "width": 1024,
      "height": 1024,
      "averageColour": "#7d7ff9"
    },
    {
      "id": "wall_clock_nor_gl_512.jpg",
      "provider": "polyhaven",
      "asset": "wall_clock",
      "kind": "texture",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Models/jpg/1k/wall_clock/wall_clock_nor_gl_1k.jpg",
      "derivedFrom": "wall_clock_nor_gl_1k.jpg",
      "sha256": "10ad44bbf4a498dab3d25a88dfa615748b214ae4823895595c07ab32ee376201",
      "stored": "10ad44bbf4a498dab3d25a88dfa615748b214ae4823895595c07ab32ee376201.jpg",
      "bytes": 23935,
      "served": true,
      "licence": "CC0-1.0",
      "worlds": [
        "museum-hall",
        "science-lab",
        "town-square"
      ],
      "width": 512,
      "height": 512,
      "averageColour": "#7d7ff9"
    },
    {
      "id": "white_plaster_02_diff_1k.jpg",
      "provider": "polyhaven",
      "asset": "white_plaster_02",
      "kind": "texture",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Textures/jpg/1k/white_plaster_02/white_plaster_02_diff_1k.jpg",
      "md5": "7b10c2686bcfd76d1f309a20fd06b57e",
      "sourceSha256": "a1ebbe091bd1ae93d2abd5de8d69f9003a8d0ee6532bcf9a87c2492c97051f23",
      "stored": "a1ebbe091bd1ae93d2abd5de8d69f9003a8d0ee6532bcf9a87c2492c97051f23.jpg",
      "bytes": 527219,
      "served": true,
      "licence": "CC0-1.0",
      "worlds": [],
      "width": 1024,
      "height": 1024,
      "averageColour": "#8e877a"
    },
    {
      "id": "white_plaster_02_nor_gl_1k.jpg",
      "provider": "polyhaven",
      "asset": "white_plaster_02",
      "kind": "texture",
      "sourceUrl": "https://dl.polyhaven.org/file/ph-assets/Textures/jpg/1k/white_plaster_02/white_plaster_02_nor_gl_1k.jpg",
      "md5": "55fc03203ebf1dc703a380fde93ff502",
      "sourceSha256": "eb572ca3630d5bfde72e2601b1f02412da23ca005cd19384dced8690be4cb783",
      "stored": "eb572ca3630d5bfde72e2601b1f02412da23ca005cd19384dced8690be4cb783.jpg",
      "bytes": 652310,
      "served": true,
      "licence": "CC0-1.0",
      "worlds": [
        "museum-hall",
        "science-lab",
        "town-square"
      ],
      "width": 1024,
      "height": 1024,
      "averageColour": "#8181fc"
    },
    {
      "id": "windmill-loop.ogg",
      "provider": "freesound",
      "asset": "windmill",
      "kind": "audio",
      "sound": "Inside a traditional Dutch windmill, 2",
      "user": "pcwvdmark",
      "page": "https://freesound.org/people/pcwvdmark/sounds/345846/",
      "licence": "CC0-1.0",
      "worlds": [
        "polder"
      ],
      "sourceUrl": "https://cdn.freesound.org/previews/345/345846_4622540-hq.ogg",
      "derivedFrom": "345846_4622540-hq.ogg",
      "sha256": "a52893ed81bd1ef4e9888c4dd93609f00d2fbfa23899cbf013f295845d3721b0",
      "stored": "a52893ed81bd1ef4e9888c4dd93609f00d2fbfa23899cbf013f295845d3721b0.ogg",
      "bytes": 166445,
      "served": true,
      "seconds": 30,
      "channels": 1,
      "sampleRate": 48000,
      "from": 0,
      "gainDb": 6.37,
      "lufs": -24.21,
      "truePeak": -3.98,
      "loop": true
    }
  ]
}
